{
	"App Settings": {
		"adminLoginPageContent": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "## Welcome to the Admin Portal\n\nThis is your digital cockpit — where mere mortals become web legends.\n\nFrom here, you can manage site content, send out envelopes (without the postage), assign roles (cue the dramatic music), and publish updates like the digital overlord you were always meant to be.\n\nWhether you're tweaking a headline, uploading a banner, or granting someone the sacred power of \"Admin Access,\" this is your command center.\n\nLog in below to get started. Just don’t forget your coffee — great things are ahead. ☕"
		},
		"aiFormClassificationInstructions": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"Contact": {
					"translations": {},
					"value": "You classify inbound website form submissions for a law firm. If the submission has message content, determine if the submission is relevant or pertains to a legal matter or if it is spam/unrelated. Submissions without message content should not be marked as spam/unrelated. Always respond using the provided JSON schema."
				}
			}
		},
		"appBuild": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "158"
		},
		"appVersion": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "1.4.25"
		},
		"buildVersion": {
			"permission": "Admin",
			"type": "TextInput",
			"value": "282"
		},
		"callrailScriptSrc": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "//cdn.callrail.com/companies/656222255/91a9e935d2c3dfa61f99/12/swap.js"
		},
		"defaultFormLayouts": {
			"permission": "Admin",
			"type": "TextArea",
			"value": "calls.0.fieldOrder.0.fieldName: Caller\ncalls.0.fieldOrder.1.fieldName: Caller Name\ncalls.0.fieldOrder.2.fieldName: Call\ncalls.0.fieldOrder.3.fieldName: Start Time\ncalls.0.groupClass: md:grid md:grid-cols-2\ncalls.0.id: 2c3d5eff-4bb0-4272-b3b9-3ce07f32247d\ncalls.0.label: Call Information\ncases.0.fieldOrder.0.fieldName: Case Name\ncases.0.fieldOrder.1.fieldName: Primary Contact Phone\ncases.0.fieldOrder.2.fieldName: Revenue Value\ncases.0.fieldOrder.3.fieldName: Primary Attribution\ncases.0.fieldOrder.4.fieldName: First Call\ncases.0.groupClass: md:grid md:grid-cols-2\ncases.0.id: d0ae2ed2-23dc-4a2a-b8b7-72c78a3e093d\ncases.0.label: Case Information\ncases.1.fieldOrder.0.fieldName: Calls\ncases.1.groupClass: md:grid md:grid-cols-2\ncases.1.id: efd372ee-5c4d-4ee8-923e-5c8fb19677c4\ncases.1.label: All Calls\ncontacts.0.fieldOrder.0.fieldName: Contact Name\ncontacts.0.fieldOrder.1.fieldName: Last Call\ncontacts.0.fieldOrder.2.fieldName: First Name\ncontacts.0.fieldOrder.3.fieldName: Roles\ncontacts.0.fieldOrder.4.fieldName: Last Name\ncontacts.0.fieldOrder.5.fieldName: Relationships\ncontacts.0.groupClass: md:grid md:grid-cols-2\ncontacts.0.id: 11677afc-cfe2-4774-8c76-533949c46c5e\ncontacts.0.label: Contact Information"
		},
		"formBanner": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": ""
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fsettings%2FApp%20Settings%2FformBanner%2Famber-logo-light.jpg?alt=media&token=85c76c8d-41bc-4ce5-add8-9d7a1c6347a9",
				"formattedSize": "10.06 KB",
				"height": 124,
				"name": "amber-logo-light.jpg",
				"path": "uploads/settings/App Settings/formBanner/amber-logo-light.jpg",
				"size": 10300,
				"type": "image/jpeg",
				"updated": "2026-03-01T14:14:54.608Z",
				"width": 351
			}
		},
		"gtmTag": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "GTM-W74F5LPB"
		},
		"index": 0,
		"initialAdminInitialized": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"labels": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"address": {
					"translations": {
						"ar": "العنوان+:+",
						"en": "Address+:+",
						"en-GB": "Address+:+",
						"en-US": "Address+:+",
						"es": "Dirección+:+",
						"es-419": "Dirección+:+",
						"es-ES": "Dirección+:+",
						"he": "כתובת+:+",
						"it": "Indirizzo+:+",
						"pl": "Adres+:+",
						"sw": "Anwani+:+",
						"tl": "Tirahan+:+",
						"vi": "Địa chỉ:",
						"zh": "地址+:+"
					},
					"value": "Address+:+"
				},
				"appUpdateMessage": {
					"translations": {
						"ar": "يتوفر إصدار جديد من التطبيق. يرجى إعادة تحميل الصفحة للحصول على أحدث الميزات.",
						"en": "A new version of the app is available. Please reload to get the latest features.",
						"en-GB": "A new version of the app is available. Please reload to get the latest features.",
						"en-US": "A new version of the app is available. Please reload to get the latest features.",
						"es": "Hay una nueva versión de la aplicación disponible. Actualízala para obtener las últimas funciones.",
						"es-419": "Hay una nueva versión de la aplicación disponible. Actualízala para obtener las últimas funciones.",
						"es-ES": "Hay una nueva versión de la aplicación disponible. Actualízala para obtener las últimas funciones.",
						"he": "גרסה חדשה של האפליקציה זמינה. אנא טען מחדש כדי לקבל את התכונות העדכניות ביותר.",
						"it": "È disponibile una nuova versione dell'app. Ricarica la pagina per ottenere le ultime funzionalità.",
						"pl": "Dostępna jest nowa wersja aplikacji. Odśwież aplikację, aby uzyskać dostęp do najnowszych funkcji.",
						"sw": "Toleo jipya la programu linapatikana. Tafadhali pakia upya ili upate vipengele vipya zaidi.",
						"tl": "May bagong bersyon na ng app. Paki-reload para makuha ang mga pinakabagong feature.",
						"vi": "Phiên bản mới của ứng dụng đã có sẵn. Vui lòng tải lại trang để cập nhật các tính năng mới nhất.",
						"zh": "应用已推出新版本，请重新加载以获取最新功能。"
					},
					"value": "A new version of the app is available. Please reload to get the latest features."
				},
				"email": {
					"translations": {
						"ar": "البريد الإلكتروني+:+",
						"en": "Email+:+",
						"en-GB": "Email+:+",
						"en-US": "Email+:+",
						"es": "Correo electrónico+:+",
						"es-419": "Correo electrónico+:+",
						"es-ES": "Correo electrónico+:+",
						"he": "אימייל+:+",
						"it": "E-mail+:+",
						"pl": "E-mail+:+",
						"sw": "Barua pepe+:+",
						"tl": "Email+:+",
						"vi": "Email+:+",
						"zh": "电子邮件+:+"
					},
					"value": "Email+:+"
				},
				"hours": {
					"translations": {
						"ar": "ساعات+:+",
						"en": "Hours+:+",
						"en-GB": "Hours+:+",
						"en-US": "Hours+:+",
						"es": "Horas+:+",
						"es-419": "Horas+:+",
						"es-ES": "Horas+:+",
						"he": "שעות+:+",
						"it": "Ore+:+",
						"pl": "Godziny+:+",
						"sw": "Saa+:+",
						"tl": "Mga Oras+:+",
						"vi": "Giờ+:+",
						"zh": "小时+:+"
					},
					"value": "Hours+:+"
				},
				"inPerson": {
					"translations": {
						"ar": "حضورياً+:+",
						"en": "In Person+:+",
						"en-GB": "In Person+:+",
						"en-US": "In Person+:+",
						"es": "En persona+:+",
						"es-419": "En persona+:+",
						"es-ES": "En persona+:+",
						"he": "באופן אישי+:+",
						"it": "Di persona+:+",
						"pl": "Osobiście+:+",
						"sw": "Ana kwa Ana+:+",
						"tl": "Nang Personal+:+",
						"vi": "Trực tiếp:+",
						"zh": "亲自到场+:+"
					},
					"value": "In Person+:+"
				},
				"phone": {
					"translations": {
						"ar": "هاتف+:+",
						"en": "Phone+:+",
						"en-GB": "Phone+:+",
						"en-US": "Phone+:+",
						"es": "Teléfono+:+",
						"es-419": "Teléfono+:+",
						"es-ES": "Teléfono+:+",
						"he": "טלפון+:+",
						"it": "Telefono+:+",
						"pl": "Telefon+:+",
						"sw": "Simu+:+",
						"tl": "Telepono+:+",
						"vi": "Điện thoại+:+",
						"zh": "电话+:+"
					},
					"value": "Phone+:+"
				},
				"ratingCountLabel": {
					"translations": {
						"ar": "إجمالي التقييمات",
						"en": "Total Reviews",
						"en-GB": "Total Reviews",
						"en-US": "Total Reviews",
						"es": "Total de reseñas",
						"es-419": "Total de reseñas",
						"es-ES": "Total de reseñas",
						"he": "סך כל הביקורות",
						"it": "Recensioni totali",
						"pl": "Łączna liczba recenzji",
						"sw": "Jumla ya Mapitio",
						"tl": "Kabuuang Mga Review",
						"vi": "Tổng số đánh giá",
						"zh": "总评论"
					},
					"value": "Total Reviews"
				},
				"relatedArticles": {
					"translations": {
						"ar": "مقالات ذات صلة",
						"en": "Related Articles",
						"en-GB": "Related Articles",
						"en-US": "Related Articles",
						"es": "Artículos relacionados",
						"es-419": "Artículos relacionados",
						"es-ES": "Artículos relacionados",
						"he": "מאמרים קשורים",
						"it": "Articoli correlati",
						"pl": "Powiązane artykuły",
						"sw": "Makala Zinazohusiana",
						"tl": "Mga Kaugnay na Artikulo",
						"vi": "Các bài viết liên quan",
						"zh": "相关文章"
					},
					"value": "Related Articles"
				},
				"reviewAction": {
					"translations": {
						"ar": "اترك تعليقًا",
						"en": "Leave a Review",
						"en-GB": "Leave a Review",
						"en-US": "Leave a Review",
						"es": "Deja una reseña",
						"es-419": "Deja una reseña",
						"es-ES": "Deja una reseña",
						"he": "השאר ביקורת",
						"it": "Lascia una recensione",
						"pl": "Zostaw recenzję",
						"sw": "Acha Mapitio",
						"tl": "Mag-iwan ng Review",
						"vi": "Để lại đánh giá",
						"zh": "留下评论"
					},
					"value": "Leave a Review"
				},
				"statTitle": {
					"translations": {
						"ar": "متوسط ​​تقييم المستخدم",
						"en": "Average User Rating",
						"en-GB": "Average User Rating",
						"en-US": "Average User Rating",
						"es": "Calificación promedio del usuario",
						"es-419": "Calificación promedio del usuario",
						"es-ES": "Calificación promedio del usuario",
						"he": "דירוג משתמש ממוצע",
						"it": "Valutazione media dell'utente",
						"pl": "Średnia ocena użytkowników",
						"sw": "Ukadiriaji wa Wastani wa Mtumiaji",
						"tl": "Karaniwang Rating ng Gumagamit",
						"vi": "Đánh giá trung bình của người dùng",
						"zh": "平均用户评分"
					},
					"value": "Average User Rating"
				},
				"tableOfContents": {
					"translations": {
						"ar": "جدول المحتويات",
						"en": "Table of Contents",
						"en-GB": "Table of Contents",
						"en-US": "Table of Contents",
						"es": "Tabla de contenido",
						"es-419": "Tabla de contenido",
						"es-ES": "Tabla de contenido",
						"he": "תוֹכֶן הָעִניָנִים",
						"it": "Sommario",
						"pl": "Spis treści",
						"sw": "Orodha ya Yaliyomo",
						"tl": "Talaan ng mga Nilalaman",
						"vi": "Mục lục",
						"zh": "目录"
					},
					"value": "Table of Contents"
				},
				"video": {
					"translations": {
						"ar": "فيديو+:+",
						"en": "Video+:+",
						"en-GB": "Video+:+",
						"en-US": "Video+:+",
						"es": "Vídeo+:+",
						"es-419": "Vídeo+:+",
						"es-ES": "Vídeo+:+",
						"he": "וידאו+:+",
						"it": "Video+:+",
						"pl": "Wideo+:+",
						"sw": "Video+:+",
						"tl": "Video+:+",
						"vi": "Video+:+",
						"zh": "视频+:+"
					},
					"value": "Video+:+"
				}
			}
		},
		"lightThemeOverwrites": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"--color-base-100": {
					"translations": {},
					"value": "oklch(10% 0 0)"
				},
				"--color-base-200": {
					"translations": {},
					"value": "oklch(15% 0 0)"
				},
				"--color-base-300": {
					"translations": {},
					"value": "oklch(20% 0 0)"
				},
				"--color-base-content": {
					"translations": {},
					"value": "oklch(97.807% 0.029 256.847)"
				},
				"--color-primary": {
					"translations": {},
					"value": "#c0a45c"
				},
				"--color-primary-content": {
					"translations": {},
					"value": "#0b0908"
				},
				"--color-secondary": {
					"translations": {},
					"value": "#E0E0DC"
				},
				"--color-secondary-content": {
					"translations": {},
					"value": "#2A2829"
				}
			}
		},
		"metaDescriptionPhone": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "(916) 907-0835"
		},
		"postWebhookFunction CallRail Post-Call 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"appSetting": {
					"translations": {},
					"value": "CallRail Post-Call Webhook"
				},
				"functionName": {
					"translations": {},
					"value": "processCallRailWebhook"
				},
				"triggerField": {
					"translations": {},
					"value": "query.source"
				},
				"triggerValue": {
					"translations": {},
					"value": "CallRail Post-Call Webhook HOLD"
				}
			}
		},
		"postWebhookFunction CallRail Post-Call 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"appSetting": {
					"translations": {},
					"value": "CallRail Post-Call Webhook"
				},
				"functionName": {
					"translations": {},
					"value": "emailCallRailCallNotification"
				},
				"triggerField": {
					"translations": {},
					"value": "query.source"
				},
				"triggerValue": {
					"translations": {},
					"value": "CallRail Post-Call Webhook HOLD"
				}
			}
		},
		"postWebhookFunction CallRail Post-Call 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"appSetting": {
					"translations": {},
					"value": "CallRail Post-Call Webhook"
				},
				"functionName": {
					"translations": {},
					"value": "textCallRailCallNotification"
				},
				"triggerField": {
					"translations": {},
					"value": "query.source"
				},
				"triggerValue": {
					"translations": {},
					"value": "CallRail Post-Call Webhook HOLD"
				}
			}
		},
		"roles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"admin": {
					"translations": {
						"ar": "المسؤول",
						"en": "Administrator",
						"en-GB": "Administrator",
						"en-US": "Administrator",
						"es": "Administrador",
						"es-419": "Administrador",
						"es-ES": "Administrador",
						"he": "מְנַהֵל",
						"it": "Amministratore",
						"pl": "Administrator",
						"sw": "Msimamizi",
						"tl": "Tagapangasiwa",
						"vi": "Quản trị viên",
						"zh": "行政人员"
					},
					"value": "Administrator"
				},
				"caseManagement": {
					"translations": {
						"ar": "إدارة الحالات",
						"en": "Case Management",
						"en-GB": "Case Management",
						"en-US": "Case Management",
						"es": "Gestión de casos",
						"es-419": "Gestión de casos",
						"es-ES": "Gestión de casos",
						"he": "ניהול תיקים",
						"it": "Gestione dei casi",
						"pl": "Zarządzanie sprawami",
						"sw": "Usimamizi wa Kesi",
						"tl": "Pamamahala ng Kaso",
						"vi": "Quản lý trường hợp",
						"zh": "个案管理"
					},
					"value": "Case Management"
				},
				"submissions": {
					"translations": {
						"ar": "المشاركات",
						"en": "Submissions",
						"en-GB": "Submissions",
						"en-US": "Submissions",
						"es": "Envíos",
						"es-419": "Envíos",
						"es-ES": "Envíos",
						"he": "הגשות",
						"it": "Invii",
						"pl": "Zgłoszenia",
						"sw": "Mawasilisho",
						"tl": "Mga Pagsusumite",
						"vi": "Bài nộp",
						"zh": "提交"
					},
					"value": "Submissions"
				}
			}
		},
		"themeCustomizations": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "body {\n\tfont-family: \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", \"Arial\" sans-serif;\n\tfont-weight: 100;\n}\n\n.marked-content h2 {\n\t@apply mt-4 sm:mt-8;\n}\n\n.marked-content h3 {\n\t@apply mt-2 sm:mt-4;\n}\n\n.marked-content hr {\n\t@apply mt-2 sm:mt-4;\n}\n\n.marked-content p {\n\t@apply leading-loose;\n}\n\n.marked-content p + p {\n\t@apply mt-1 sm:mt-2;\n}"
		}
	},
	"FloatingMenu": {
		"Action 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "الهاتف: +19167150890",
						"en": "tel:+19167150890",
						"en-GB": "tel:+19167150890",
						"en-US": "tel:+19167150890",
						"es": "teléfono: +19167150890",
						"es-419": "teléfono: +19167150890",
						"es-ES": "teléfono: +19167150890",
						"he": "טלפון: 19167150890+",
						"it": "tel:+19167150890",
						"pl": "tel.:+19167150890",
						"sw": "simu:+19167150890",
						"tl": "telepono:+19167150890",
						"vi": "Điện thoại: +19167150890",
						"zh": "电话：+19167150890"
					},
					"value": "tel:+19167150890"
				},
				"label": {
					"translations": {
						"ar": "يتصل",
						"en": "Call",
						"en-GB": "Call",
						"en-US": "Call",
						"es": "Llamar",
						"es-419": "Llamar",
						"es-ES": "Llamar",
						"he": "שִׂיחָה",
						"it": "Chiamata",
						"pl": "Dzwonić",
						"sw": "Piga simu",
						"tl": "Tumawag",
						"vi": "Gọi",
						"zh": "称呼"
					},
					"value": "Call"
				}
			}
		},
		"Action 01 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z\"]}",
				"name": "faPhone"
			}
		},
		"Action 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "/اتصال/",
						"en": "/contact/",
						"en-GB": "/contact/",
						"en-US": "/contact/",
						"es": "/contacto/",
						"es-419": "/contacto/",
						"es-ES": "/contacto/",
						"he": "/מַגָע/",
						"it": "/contatto/",
						"pl": "/kontakt/",
						"sw": "/wasiliana/",
						"tl": "/makipag-ugnayan/",
						"vi": "/liên hệ/",
						"zh": "/接触/"
					},
					"value": "/contact/"
				},
				"label": {
					"translations": {
						"ar": "اتصال",
						"en": "Contact",
						"en-GB": "Contact",
						"en-US": "Contact",
						"es": "Contacto",
						"es-419": "Contacto",
						"es-ES": "Contacto",
						"he": "מַגָע",
						"it": "Contatto",
						"pl": "Kontakt",
						"sw": "Mawasiliano",
						"tl": "Makipag-ugnayan",
						"vi": "Liên hệ",
						"zh": "接触"
					},
					"value": "Contact"
				}
			}
		},
		"Action 02 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"people-arrows\",\"icon\":[512,512,[\"people-arrows-left-right\"],\"e068\",\"M32 64A64 64 0 1 1 160 64 64 64 0 1 1 32 64zM0 224c0-35.3 28.7-64 64-64l64 0c3.2 0 6.4 .2 9.5 .7L93.1 205.1C65 233.2 65 278.8 93.1 306.9l56 56c3.4 3.4 7 6.4 10.9 9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-120.6C12.9 332.4 0 311.7 0 288l0-64zM352 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm66.9 141.1l-44.4-44.4c3.1-.5 6.3-.7 9.5-.7l64 0c35.3 0 64 28.7 64 64l0 64c0 23.7-12.9 44.4-32 55.4L480 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1c3.9-2.6 7.5-5.6 10.9-9l56-56c28.1-28.1 28.1-73.7 0-101.8zM302.8 177.8c9-3.7 19.3-1.7 26.2 5.2l56 56c9.4 9.4 9.4 24.6 0 33.9l-56 56c-6.9 6.9-17.2 8.9-26.2 5.2S288 321.7 288 312l0-24-64 0 0 24c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-56-56c-9.4-9.4-9.4-24.6 0-33.9l56-56c6.9-6.9 17.2-8.9 26.2-5.2S224 190.3 224 200l0 24 64 0 0-24c0-9.7 5.8-18.5 14.8-22.2z\"]}",
				"name": "faPeopleArrows"
			}
		},
		"Action 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"en": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"en-GB": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"en-US": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"es": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"es-419": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"es-ES": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"he": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"it": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"pl": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"sw": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"tl": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"vi": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508",
						"zh": "https://thelawofficesofamberbellante.cliogrow.com/book/9f7d4947fe044a186f283fde02544508"
					},
					"value": "https://calendly.com/amberbellante/new-meeting"
				},
				"label": {
					"translations": {
						"ar": "جدول",
						"en": "Schedule",
						"en-GB": "Schedule",
						"en-US": "Schedule",
						"es": "Cronograma",
						"es-419": "Cronograma",
						"es-ES": "Cronograma",
						"he": "לוּחַ זְמַנִים",
						"it": "Programma",
						"pl": "Harmonogram",
						"sw": "Ratiba",
						"tl": "Iskedyul",
						"vi": "Lịch trình",
						"zh": "日程"
					},
					"value": "Schedule"
				}
			}
		},
		"Action 03 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"calendar-days\",\"icon\":[448,512,[\"calendar-alt\"],\"f073\",\"M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zM64 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z\"]}",
				"name": "faCalendarAlt"
			}
		},
		"Action 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"en": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"en-GB": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"en-US": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"es": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"es-419": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"es-ES": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"he": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"it": "Italiano: https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"pl": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"sw": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"tl": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"vi": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13",
						"zh": "https://app.clio.com/link/v2/2/2/3073e6b72071fa94dffc9f678f0aa5af?hmac=3e560db6e5e448a77f320ebfe0f10393f22b5e4818494bb15a6d465fdfd74a13"
					},
					"value": "https://app.clio.com/link/v2/2/2/9ce21a711cb08913210ed6cfcf869575?hmac=d2f68cbe62c0be94caceea1db9ae5be46c7a476fab2d374cfa6b8b855cbb0b03"
				},
				"label": {
					"translations": {
						"ar": "يدفع",
						"en": "Pay",
						"en-GB": "Pay",
						"en-US": "Pay",
						"es": "Pagar",
						"es-419": "Pagar",
						"es-ES": "Pagar",
						"he": "לְשַׁלֵם",
						"it": "Paga",
						"pl": "Płacić",
						"sw": "Lipa",
						"tl": "Bayad",
						"vi": "Chi trả",
						"zh": "支付"
					},
					"value": "Pay"
				}
			}
		},
		"Action 04 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"dollar-sign\",\"icon\":[320,512,[128178,61781,\"dollar\",\"usd\"],\"24\",\"M136 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-114.9 0c-24.9 0-45.1 20.2-45.1 45.1 0 22.5 16.5 41.5 38.7 44.7l91.6 13.1c53.8 7.7 93.7 53.7 93.7 108 0 60.3-48.9 109.1-109.1 109.1l-10.9 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-72 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l130.9 0c24.9 0 45.1-20.2 45.1-45.1 0-22.5-16.5-41.5-38.7-44.7l-91.6-13.1C55.9 273.5 16 227.4 16 173.1 16 112.9 64.9 64 125.1 64l10.9 0 0-40z\"]}",
				"name": "faDollar"
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"asideClass": {
					"translations": {},
					"value": "fixed bottom-8 sm:right-4 flex flex-row justify-between sm:flex-col sm:items-end gap-2 z-50 w-full sm:w-auto"
				}
			}
		},
		"index": 1
	},
	"Footer": {
		"copyrightTag": {
			"permission": "Admin",
			"translations": {
				"ar": "جميع الحقوق محفوظة.",
				"en": "All Rights Reserved.",
				"en-GB": "All Rights Reserved.",
				"en-US": "All Rights Reserved.",
				"es": "Reservados todos los derechos.",
				"es-419": "Reservados todos los derechos.",
				"es-ES": "Reservados todos los derechos.",
				"he": "כֹּל הַזְכוּיוֹת שְׁמוּרוֹת.",
				"it": "Tutti i diritti riservati.",
				"pl": "Wszelkie prawa zastrzeżone.",
				"sw": "Haki Zote Zimehifadhiwa.",
				"tl": "Nakalaan ang Lahat ng Karapatan.",
				"vi": "Bản quyền đã được bảo lưu.",
				"zh": "版权所有。"
			},
			"type": "TextInput",
			"value": "All Rights Reserved."
		},
		"index": 2,
		"showGoogleReviews": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"Head": {
		"defaultDescription": {
			"permission": "Admin",
			"translations": {
				"ar": "احصل على دفاع قوي في قضايا القيادة تحت تأثير الكحول والقضايا الجنائية بخبرة تزيد عن 23 عامًا. تواصل معنا اليوم للحصول على استراتيجية قانونية مصممة خصيصًا لك!",
				"en": "Get aggressive DUI & criminal defense with 23+ years of experience. Contact us for a tailored legal strategy today!",
				"en-GB": "Get aggressive DUI & criminal defense with 23+ years of experience. Contact us for a tailored legal strategy today!",
				"en-US": "Get aggressive DUI & criminal defense with 23+ years of experience. Contact us for a tailored legal strategy today!",
				"es": "Obtenga una defensa agresiva contra DUI y casos penales con más de 23 años de experiencia. ¡Contáctenos hoy mismo para una estrategia legal personalizada!",
				"es-419": "Obtenga una defensa agresiva contra DUI y casos penales con más de 23 años de experiencia. ¡Contáctenos hoy mismo para una estrategia legal personalizada!",
				"es-ES": "Obtenga una defensa agresiva contra DUI y casos penales con más de 23 años de experiencia. ¡Contáctenos hoy mismo para una estrategia legal personalizada!",
				"he": "קבלו הגנה אגרסיבית בנהיגה בשכרות ובפלילים עם ניסיון של למעלה מ-23 שנה. צרו קשר עוד היום לקבלת אסטרטגיה משפטית מותאמת אישית!",
				"it": "Ottieni una difesa aggressiva in caso di guida in stato di ebbrezza e reati penali con oltre 23 anni di esperienza. Contattaci oggi stesso per una strategia legale personalizzata!",
				"pl": "Skorzystaj z agresywnej obrony w sprawach DUI i sprawach karnych dzięki ponad 23-letniemu doświadczeniu. Skontaktuj się z nami już dziś, aby uzyskać spersonalizowaną strategię prawną!",
				"sw": "Pata utetezi mkali wa DUI na jinai ukiwa na uzoefu wa miaka 23+. Wasiliana nasi kwa mkakati wa kisheria uliobinafsishwa leo!",
				"tl": "Kumuha ng agresibong depensa laban sa DUI at kriminal na may mahigit 23 taong karanasan. Makipag-ugnayan sa amin para sa isang pinasadyang legal na estratehiya ngayon!",
				"vi": "Nhận được sự bào chữa mạnh mẽ cho các vụ án DUI và hình sự với hơn 23 năm kinh nghiệm. Liên hệ với chúng tôi ngay hôm nay để được tư vấn chiến lược pháp lý phù hợp!",
				"zh": "我们拥有超过23年的经验，为您提供强有力的酒驾和刑事辩护。立即联系我们，制定专属的法律策略！"
			},
			"type": "TextArea",
			"value": "Get aggressive DUI & criminal defense with 23+ years of experience. Contact us for a tailored legal strategy today!"
		},
		"defaultIcon": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "دائرة ذهبية عليها الحرفان A و B مكتوبان بخط أبيض",
						"en": "Gold circle with the letters A and B in white script",
						"en-GB": "Gold circle with the letters A and B in white script",
						"en-US": "Gold circle with the letters A and B in white script",
						"es": "Círculo dorado con las letras A y B en escritura blanca.",
						"es-419": "Círculo dorado con las letras A y B en escritura blanca.",
						"es-ES": "Círculo dorado con las letras A y B en escritura blanca.",
						"he": "עיגול זהב עם האותיות A ו-B בכתב לבן",
						"it": "Cerchio dorato con le lettere A e B in caratteri bianchi",
						"pl": "Złoty okrąg z literami A i B w białym napisie",
						"sw": "Mduara wa dhahabu wenye herufi A na B katika hati nyeupe",
						"tl": "Gintong bilog na may mga letrang A at B sa puting sulat",
						"vi": "Hình tròn màu vàng với chữ A và B viết bằng chữ trắng.",
						"zh": "金色圆圈，上面用白色字体写着字母 A 和 B。"
					},
					"value": "Gold circle with the letters A and B in white script"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fsettings%2FHead%2FdefaultIcon%2Fab-logo-512.png?alt=media&token=2b64d404-83cf-4d04-9f9e-5fc656059708",
				"formattedSize": "85.70 KB",
				"height": 512,
				"name": "ab-logo-512.png",
				"path": "uploads/settings/Head/defaultIcon/ab-logo-512.png",
				"query": "?as=run",
				"size": 87755,
				"type": "image/png",
				"updated": "2026-01-10T21:18:55.263Z",
				"width": 512
			}
		},
		"defaultImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "A woman in a blue jacket is smiling with her hands on her hips",
						"en-GB": "A woman in a blue jacket is smiling with her hands on her hips",
						"en-US": "A woman in a blue jacket is smiling with her hands on her hips",
						"es": "Una mujer con una chaqueta azul sonríe con las manos en las caderas.",
						"es-419": "Una mujer con una chaqueta azul sonríe con las manos en las caderas.",
						"es-ES": "Una mujer con una chaqueta azul sonríe con las manos en las caderas.",
						"sw": "Mwanamke aliyevaa koti la bluu anatabasamu huku mikono yake ikiwa kiunoni",
						"zh": "一位身穿蓝色外套的女子双手叉腰，面带微笑。"
					},
					"value": "A woman in a blue jacket is smiling with her hands on her hips"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fsettings%2FHead%2FdefaultImage%2FAB-Hero-Image-Mocks--281-29.png?alt=media&token=8d0c0589-cc7a-438f-b8fa-ae0d7efff2e8",
				"formattedSize": "235.81 KB",
				"height": 634,
				"name": "AB-Hero-Image-Mocks--281-29.png",
				"path": "uploads/settings/Head/defaultImage/AB-Hero-Image-Mocks--281-29.png",
				"query": "?as=run",
				"size": 241467,
				"type": "image/png",
				"updated": "2025-12-04T12:25:15.202Z",
				"width": 573
			}
		},
		"index": 3
	},
	"Header": {
		"Menu 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {
						"ar": "الرئيسية، المنشورات",
						"en": "home, posts",
						"en-GB": "home, posts",
						"en-US": "home, posts",
						"es": "inicio, publicaciones",
						"es-419": "inicio, publicaciones",
						"es-ES": "inicio, publicaciones",
						"he": "בית, פוסטים",
						"it": "casa, post",
						"pl": "strona główna, posty",
						"sw": "nyumbani, machapisho",
						"tl": "bahay, mga post",
						"vi": "trang chủ, bài đăng",
						"zh": "首页，帖子"
					},
					"value": "home, articles, services"
				},
				"href": {
					"translations": {
						"ar": "/",
						"en": "/",
						"en-GB": "/",
						"en-US": "/",
						"es": "/",
						"es-419": "/",
						"es-ES": "/",
						"he": "/",
						"it": "/",
						"pl": "/",
						"sw": "/",
						"tl": "/",
						"vi": "/",
						"zh": "/"
					},
					"value": "/"
				},
				"label": {
					"translations": {
						"ar": "بيت",
						"en": "Home",
						"en-GB": "Home",
						"en-US": "Home",
						"es": "Hogar",
						"es-419": "Hogar",
						"es-ES": "Hogar",
						"he": "בַּיִת",
						"it": "Casa",
						"pl": "Dom",
						"sw": "Nyumbani",
						"tl": "Tahanan",
						"vi": "Trang chủ",
						"zh": "家"
					},
					"value": "Home"
				}
			}
		},
		"Menu 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {
						"ar": "مجالات الممارسة والخدمات",
						"en": "practice areas, services",
						"en-GB": "practice areas, services",
						"en-US": "practice areas, services",
						"es": "áreas de práctica, servicios",
						"es-419": "áreas de práctica, servicios",
						"es-ES": "áreas de práctica, servicios",
						"he": "תחומי עיסוק, שירותים",
						"it": "aree di pratica, servizi",
						"pl": "obszary praktyki, usługi",
						"sw": "maeneo ya mazoezi, huduma",
						"tl": "mga lugar ng pagsasanay, mga serbisyo",
						"vi": "các lĩnh vực hành nghề, dịch vụ",
						"zh": "业务领域、服务"
					},
					"value": "practice areas, services"
				},
				"href": {
					"translations": {
						"ar": "القيادة تحت تأثير الكحول",
						"en": "/DUI/",
						"en-GB": "/DUI/",
						"en-US": "/DUI/",
						"es": "/Conducir bajo los efectos del alcohol/",
						"es-419": "/Conducir bajo los efectos del alcohol/",
						"es-ES": "/Conducir bajo los efectos del alcohol/",
						"he": "/נהיגה בשכרות/",
						"it": "/Guida in stato di ebbrezza/",
						"pl": "/Jazda pod wpływem alkoholu/",
						"sw": "/DUI/",
						"tl": "/DUI/",
						"vi": "/Lái xe trong tình trạng say xỉn/",
						"zh": "/酒后驾车/"
					},
					"value": "/DUI/"
				},
				"label": {
					"translations": {
						"ar": "القيادة تحت تأثير الكحول",
						"en": "DUI",
						"en-GB": "DUI",
						"en-US": "DUI",
						"es": "Conducir bajo los efectos del alcohol",
						"es-419": "Conducir bajo los efectos del alcohol",
						"es-ES": "Conducir bajo los efectos del alcohol",
						"he": "נהיגה תחת השפעת אלכוהול",
						"it": "Guida in stato di ebbrezza",
						"pl": "Jazda pod wpływem alkoholu",
						"sw": "DUI",
						"tl": "DUI",
						"vi": "lái xe say rượu",
						"zh": "酒后驾车"
					},
					"value": "DUI"
				}
			}
		},
		"Menu 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {
						"ar": "مجالات الممارسة والخدمات",
						"en": "practice areas, services",
						"en-GB": "practice areas, services",
						"en-US": "practice areas, services",
						"es": "áreas de práctica, servicios",
						"es-419": "áreas de práctica, servicios",
						"es-ES": "áreas de práctica, servicios",
						"he": "תחומי עיסוק, שירותים",
						"it": "aree di pratica, servizi",
						"pl": "obszary praktyki, usługi",
						"sw": "maeneo ya mazoezi, huduma",
						"tl": "mga lugar ng pagsasanay, mga serbisyo",
						"vi": "các lĩnh vực hành nghề, dịch vụ",
						"zh": "业务领域、服务"
					},
					"value": "practice areas, services"
				},
				"href": {
					"translations": {
						"ar": "/الدفاع الجنائي/",
						"en": "/Criminal-Defense/",
						"en-GB": "/Criminal-Defense/",
						"en-US": "/Criminal-Defense/",
						"es": "/Defensa Penal/",
						"es-419": "/Defensa Penal/",
						"es-ES": "/Defensa Penal/",
						"he": "/הגנה פלילית/",
						"it": "/Difesa penale/",
						"pl": "/Obrona karna/",
						"sw": "/Ulinzi wa Jinai/",
						"tl": "/Depensa sa Kriminal/",
						"vi": "/Luật Hình sự/",
						"zh": "刑事辩护"
					},
					"value": "/Criminal-Defense/"
				},
				"label": {
					"translations": {
						"ar": "الدفاع الجنائي",
						"en": "Criminal Defense",
						"en-GB": "Criminal Defense",
						"en-US": "Criminal Defense",
						"es": "Defensa Penal",
						"es-419": "Defensa Penal",
						"es-ES": "Defensa Penal",
						"he": "הגנה פלילית",
						"it": "Difesa penale",
						"pl": "Obrona karna",
						"sw": "Ulinzi wa Jinai",
						"tl": "Depensa sa Kriminal",
						"vi": "Luật sư bào chữa hình sự",
						"zh": "刑事辩护"
					},
					"value": "Criminal Defense"
				}
			}
		},
		"Menu 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {
						"ar": "مجالات الممارسة والخدمات",
						"en": "practice areas, services",
						"en-GB": "practice areas, services",
						"en-US": "practice areas, services",
						"es": "áreas de práctica, servicios",
						"es-419": "áreas de práctica, servicios",
						"es-ES": "áreas de práctica, servicios",
						"he": "תחומי עיסוק, שירותים",
						"it": "aree di pratica, servizi",
						"pl": "obszary praktyki, usługi",
						"sw": "maeneo ya mazoezi, huduma",
						"tl": "mga lugar ng pagsasanay, mga serbisyo",
						"vi": "các lĩnh vực hành nghề, dịch vụ",
						"zh": "业务领域、服务"
					},
					"value": "practice areas, services"
				},
				"href": {
					"translations": {
						"ar": "/جلسة استماع إدارة المركبات الآلية/",
						"en": "/DMV-Hearing/",
						"en-GB": "/DMV-Hearing/",
						"en-US": "/DMV-Hearing/",
						"es": "/DMV-Audiencia/",
						"es-419": "/DMV-Audiencia/",
						"es-ES": "/DMV-Audiencia/",
						"he": "/דיון במשרד הרישוי/",
						"it": "/DMV-Udienza/",
						"pl": "/DMV-Przesłuchanie/",
						"sw": "/Usikilizaji wa DMV/",
						"tl": "/Pagdinig sa DMV/",
						"vi": "/DMV-Hearing/",
						"zh": "/DMV听证会/"
					},
					"value": "/DMV-Hearing/"
				},
				"label": {
					"translations": {
						"ar": "جلسة استماع إدارة المركبات الآلية",
						"en": "DMV Hearing",
						"en-GB": "DMV Hearing",
						"en-US": "DMV Hearing",
						"es": "Audiencia del DMV",
						"es-419": "Audiencia del DMV",
						"es-ES": "Audiencia del DMV",
						"he": "שימוע במשרד הרישוי",
						"it": "Udienza DMV",
						"pl": "Przesłuchanie w DMV",
						"sw": "Usikivu wa DMV",
						"tl": "Pagdinig ng DMV",
						"vi": "Phiên điều trần DMV",
						"zh": "车管所听证会"
					},
					"value": "DMV Hearing"
				}
			}
		},
		"Menu 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"cols": {
					"translations": {
						"ar": "مجالات الممارسة والخدمات",
						"en": "practice areas, services",
						"en-GB": "practice areas, services",
						"en-US": "practice areas, services",
						"es": "áreas de práctica, servicios",
						"es-419": "áreas de práctica, servicios",
						"es-ES": "áreas de práctica, servicios",
						"he": "תחומי עיסוק, שירותים",
						"it": "aree di pratica, servizi",
						"pl": "obszary praktyki, usługi",
						"sw": "maeneo ya mazoezi, huduma",
						"tl": "mga lugar ng pagsasanay, mga serbisyo",
						"vi": "các lĩnh vực hành nghề, dịch vụ",
						"zh": "业务领域、服务"
					},
					"value": "practice areas, services"
				},
				"href": {
					"translations": {
						"ar": "محو السجل الجنائي",
						"en": "/Expungement/",
						"en-GB": "/Expungement/",
						"en-US": "/Expungement/",
						"es": "/Eliminación de antecedentes penales/",
						"es-419": "/Eliminación de antecedentes penales/",
						"es-ES": "/Eliminación de antecedentes penales/",
						"he": "/מחיקה/",
						"it": "/Cancellazione/",
						"pl": "/Usunięcie/",
						"sw": "/Kufuta/",
						"tl": "/Pag-aalis/",
						"vi": "/Xóa án tích/",
						"zh": "/记录清除/"
					},
					"value": "/Expungement/"
				},
				"label": {
					"translations": {
						"ar": "شطب السجل الجنائي",
						"en": "Expungement",
						"en-GB": "Expungement",
						"en-US": "Expungement",
						"es": "Eliminación de antecedentes penales",
						"es-419": "Eliminación de antecedentes penales",
						"es-ES": "Eliminación de antecedentes penales",
						"he": "מחיקה",
						"it": "Cancellazione",
						"pl": "Wymazanie",
						"sw": "Kufutwa",
						"tl": "Pag-aalis",
						"vi": "Xóa án tích",
						"zh": "清除犯罪记录"
					},
					"value": "Expungement"
				}
			}
		},
		"Menu 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {
						"ar": "خدمات",
						"en": "services",
						"en-GB": "services",
						"en-US": "services",
						"es": "servicios",
						"es-419": "servicios",
						"es-ES": "servicios",
						"he": "שירותים",
						"it": "servizi",
						"pl": "usługi",
						"sw": "huduma",
						"tl": "mga serbisyo",
						"vi": "dịch vụ",
						"zh": "服务"
					},
					"value": "services"
				},
				"cols": {
					"translations": {
						"ar": "مجالات الممارسة والخدمات",
						"en": "practice areas, services",
						"en-GB": "practice areas, services",
						"en-US": "practice areas, services",
						"es": "áreas de práctica, servicios",
						"es-419": "áreas de práctica, servicios",
						"es-ES": "áreas de práctica, servicios",
						"he": "תחומי עיסוק, שירותים",
						"it": "aree di pratica, servizi",
						"pl": "obszary praktyki, usługi",
						"sw": "maeneo ya mazoezi, huduma",
						"tl": "mga lugar ng pagsasanay, mga serbisyo",
						"vi": "các lĩnh vực hành nghề, dịch vụ",
						"zh": "业务领域、服务"
					},
					"value": "practice areas, services"
				},
				"hide": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"href": {
					"translations": {
						"ar": "/مجالات التدريب/",
						"en": "/practice-areas/",
						"en-GB": "/practice-areas/",
						"en-US": "/practice-areas/",
						"es": "/áreas-de-práctica/",
						"es-419": "/áreas-de-práctica/",
						"es-ES": "/áreas-de-práctica/",
						"he": "/תחומי-תרגול/",
						"it": "/aree-di-pratica/",
						"pl": "/obszary-praktyki/",
						"sw": "/maeneo-ya-mazoezi/",
						"tl": "/mga-lugar-ng-pagsasanay/",
						"vi": "/lĩnh vực thực hành/",
						"zh": "/实践领域/"
					},
					"value": "/practice-areas/"
				},
				"label": {
					"translations": {
						"ar": "مجالات الممارسة",
						"en": "Practice Areas",
						"en-GB": "Practice Areas",
						"en-US": "Practice Areas",
						"es": "Áreas de práctica",
						"es-419": "Áreas de práctica",
						"es-ES": "Áreas de práctica",
						"he": "תחומי עיסוק",
						"it": "Aree di competenza",
						"pl": "Obszary praktyki",
						"sw": "Maeneo ya Mazoezi",
						"tl": "Mga Lugar ng Pagsasanay",
						"vi": "Các lĩnh vực thực hành",
						"zh": "业务领域"
					},
					"value": "Practice Areas"
				},
				"optionHref": {
					"translations": {
						"ar": "لانغ، مفتاح",
						"en": "lang, key",
						"en-GB": "lang, key",
						"en-US": "lang, key",
						"es": "idioma, clave",
						"es-419": "idioma, clave",
						"es-ES": "idioma, clave",
						"he": "שפה, מפתח",
						"it": "lingua, chiave",
						"pl": "język, klucz",
						"sw": "lugha, ufunguo",
						"tl": "wika, susi",
						"vi": "lang, key",
						"zh": "语言，关键"
					},
					"value": "lang, key"
				},
				"options": {
					"translations": {
						"ar": "خدمات",
						"en": "services",
						"en-GB": "services",
						"en-US": "services",
						"es": "servicios",
						"es-419": "servicios",
						"es-ES": "servicios",
						"he": "שירותים",
						"it": "servizi",
						"pl": "usługi",
						"sw": "huduma",
						"tl": "mga serbisyo",
						"vi": "dịch vụ",
						"zh": "服务"
					},
					"value": "services"
				}
			}
		},
		"Menu 07": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "/حول-أمبر/",
						"en": "/About-Amber/",
						"en-GB": "/About-Amber/",
						"en-US": "/About-Amber/",
						"es": "/Acerca de Ámbar/",
						"es-419": "/Acerca de Ámbar/",
						"es-ES": "/Acerca de Ámbar/",
						"he": "/אודות-אמבר/",
						"it": "/Informazioni su Amber/",
						"pl": "/O-Amber/",
						"sw": "/Kuhusu-Kaharabu/",
						"tl": "/Tungkol-kay-Amber/",
						"vi": "/Giới thiệu về Amber/",
						"zh": "/关于琥珀/"
					},
					"value": "/About-Amber/"
				},
				"label": {
					"translations": {
						"ar": "عن",
						"en": "About",
						"en-GB": "About",
						"en-US": "About",
						"es": "Acerca de",
						"es-419": "Acerca de",
						"es-ES": "Acerca de",
						"he": "אוֹדוֹת",
						"it": "Di",
						"pl": "O",
						"sw": "Kuhusu",
						"tl": "Tungkol sa",
						"vi": "Về",
						"zh": "关于"
					},
					"value": "About"
				}
			}
		},
		"Menu 08": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {
						"ar": "مقالات",
						"en": "articles",
						"en-GB": "articles",
						"en-US": "articles",
						"es": "artículos",
						"es-419": "artículos",
						"es-ES": "artículos",
						"he": "מאמרים",
						"it": "articoli",
						"pl": "artykuły",
						"sw": "makala",
						"tl": "mga artikulo",
						"vi": "bài viết",
						"zh": "文章"
					},
					"value": "articles"
				},
				"cols": {
					"translations": {
						"ar": "أخبار ومقالات",
						"en": "news, articles",
						"en-GB": "news, articles",
						"en-US": "news, articles",
						"es": "noticias, artículos",
						"es-419": "noticias, artículos",
						"es-ES": "noticias, artículos",
						"he": "חדשות, מאמרים",
						"it": "notizie, articoli",
						"pl": "wiadomości, artykuły",
						"sw": "habari, makala",
						"tl": "balita, mga artikulo",
						"vi": "tin tức, bài báo",
						"zh": "新闻、文章"
					},
					"value": "news, articles"
				},
				"href": {
					"translations": {
						"ar": "/أخبار/",
						"en": "/news/",
						"en-GB": "/news/",
						"en-US": "/news/",
						"es": "/noticias/",
						"es-419": "/noticias/",
						"es-ES": "/noticias/",
						"he": "/חֲדָשׁוֹת/",
						"it": "/notizia/",
						"pl": "/aktualności/",
						"sw": "/habari/",
						"tl": "/balita/",
						"vi": "/tin tức/",
						"zh": "/消息/"
					},
					"value": "/news/"
				},
				"label": {
					"translations": {
						"ar": "أخبار",
						"en": "News",
						"en-GB": "News",
						"en-US": "News",
						"es": "Noticias",
						"es-419": "Noticias",
						"es-ES": "Noticias",
						"he": "חֲדָשׁוֹת",
						"it": "Notizia",
						"pl": "Aktualności",
						"sw": "Habari",
						"tl": "Balita",
						"vi": "Tin tức",
						"zh": "消息"
					},
					"value": "News"
				},
				"optionHref": {
					"translations": {
						"ar": "لانغ، مفتاح",
						"en": "lang, key",
						"en-GB": "lang, key",
						"en-US": "lang, key",
						"es": "idioma, clave",
						"es-419": "idioma, clave",
						"es-ES": "idioma, clave",
						"he": "שפה, מפתח",
						"it": "lingua, chiave",
						"pl": "język, klucz",
						"sw": "lugha, ufunguo",
						"tl": "wika, susi",
						"vi": "lang, key",
						"zh": "语言，关键"
					},
					"value": "lang, key"
				},
				"options": {
					"translations": {
						"ar": "مقالات",
						"en": "articles",
						"en-GB": "articles",
						"en-US": "articles",
						"es": "artículos",
						"es-419": "artículos",
						"es-ES": "artículos",
						"he": "מאמרים",
						"it": "articoli",
						"pl": "artykuły",
						"sw": "makala",
						"tl": "mga artikulo",
						"vi": "bài viết",
						"zh": "文章"
					},
					"value": "articles"
				}
			}
		},
		"Menu 09": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {
						"ar": "مواقعنا",
						"en": "our locations",
						"en-GB": "our locations",
						"en-US": "our locations",
						"es": "Nuestras ubicaciones",
						"es-419": "Nuestras ubicaciones",
						"es-ES": "Nuestras ubicaciones",
						"he": "המיקומים שלנו",
						"it": "le nostre sedi",
						"pl": "nasze lokalizacje",
						"sw": "maeneo yetu",
						"tl": "ang aming mga lokasyon",
						"vi": "địa điểm của chúng tôi",
						"zh": "我们的地点"
					},
					"value": "our locations"
				},
				"label": {
					"translations": {
						"ar": "المواقع",
						"en": "Locations",
						"en-GB": "Locations",
						"en-US": "Locations",
						"es": "Ubicaciones",
						"es-419": "Ubicaciones",
						"es-ES": "Ubicaciones",
						"he": "מיקומים",
						"it": "Posizioni",
						"pl": "Lokalizacje",
						"sw": "Maeneo",
						"tl": "Mga Lokasyon",
						"vi": "Địa điểm",
						"zh": "地点"
					},
					"value": "Locations"
				},
				"optionHref": {
					"translations": {
						"ar": "cfg.optionPath.value، نقطة النهاية",
						"en": "cfg.optionPath.value, endpoint",
						"en-GB": "cfg.optionPath.value, endpoint",
						"en-US": "cfg.optionPath.value, endpoint",
						"es": "cfg.optionPath.value, punto final",
						"es-419": "cfg.optionPath.value, punto final",
						"es-ES": "cfg.optionPath.value, punto final",
						"he": "cfg.optionPath.value, נקודת קצה",
						"it": "cfg.optionPath.value, punto finale",
						"pl": "cfg.optionPath.value, punkt końcowy",
						"sw": "cfg.optionPath.thamani, sehemu ya mwisho",
						"tl": "cfg.optionPath.value, endpoint",
						"vi": "cfg.optionPath.value, endpoint",
						"zh": "cfg.optionPath.value，端点"
					},
					"value": "cfg.optionPath.value, endpoint"
				},
				"optionLabel": {
					"translations": {
						"ar": "src.label",
						"en": "src.label",
						"en-GB": "src.label",
						"en-US": "src.label",
						"es": "etiqueta src.",
						"es-419": "etiqueta src.",
						"es-ES": "etiqueta src.",
						"he": "src.label",
						"it": "etichetta src.",
						"pl": "Źródło etykiety",
						"sw": "lebo ya src",
						"tl": "src.label",
						"vi": "src.label",
						"zh": "src.label"
					},
					"value": "src.label"
				},
				"optionPath": {
					"translations": {
						"ar": "المواقع",
						"en": "Locations",
						"en-GB": "Locations",
						"en-US": "Locations",
						"es": "Ubicaciones",
						"es-419": "Ubicaciones",
						"es-ES": "Ubicaciones",
						"he": "מיקומים",
						"it": "Posizioni",
						"pl": "Lokalizacje",
						"sw": "Maeneo",
						"tl": "Mga Lokasyon",
						"vi": "Địa điểm",
						"zh": "地点"
					},
					"value": "Locations"
				},
				"options": {
					"translations": {
						"ar": "المواقع",
						"en": "locations",
						"en-GB": "locations",
						"en-US": "locations",
						"es": "ubicaciones",
						"es-419": "ubicaciones",
						"es-ES": "ubicaciones",
						"he": "מיקומים",
						"it": "posizioni",
						"pl": "lokalizacje",
						"sw": "maeneo",
						"tl": "mga lokasyon",
						"vi": "địa điểm",
						"zh": "地点"
					},
					"value": "locations"
				}
			}
		},
		"Menu 10": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {
						"ar": "اتصل بنا",
						"en": "contact us",
						"en-GB": "contact us",
						"en-US": "contact us",
						"es": "Contáctanos",
						"es-419": "Contáctanos",
						"es-ES": "Contáctanos",
						"he": "צרו קשר",
						"it": "contattaci",
						"pl": "Skontaktuj się z nami",
						"sw": "Wasiliana nasi",
						"tl": "makipag-ugnayan sa amin",
						"vi": "liên hệ với chúng tôi",
						"zh": "联系我们"
					},
					"value": "contact us"
				},
				"href": {
					"translations": {
						"ar": "/اتصال/",
						"en": "/contact/",
						"en-GB": "/contact/",
						"en-US": "/contact/",
						"es": "/contacto/",
						"es-419": "/contacto/",
						"es-ES": "/contacto/",
						"he": "/מַגָע/",
						"it": "/contatto/",
						"pl": "/kontakt/",
						"sw": "/wasiliana/",
						"tl": "/makipag-ugnayan/",
						"vi": "/liên hệ/",
						"zh": "/接触/"
					},
					"value": "/contact/"
				},
				"label": {
					"translations": {
						"ar": "اتصال",
						"en": "Contact",
						"en-GB": "Contact",
						"en-US": "Contact",
						"es": "Contacto",
						"es-419": "Contacto",
						"es-ES": "Contacto",
						"he": "מַגָע",
						"it": "Contatto",
						"pl": "Kontakt",
						"sw": "Mawasiliano",
						"tl": "Makipag-ugnayan",
						"vi": "Liên hệ",
						"zh": "接触"
					},
					"value": "Contact"
				}
			}
		},
		"Menu 11": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"baseClass": {
					"translations": {
						"ar": "نص أساسي، خط شبه عريض، نص كبير جدًا",
						"en": "text-primary font-semibold text-xl",
						"en-GB": "text-primary font-semibold text-xl",
						"en-US": "text-primary font-semibold text-xl",
						"es": "texto-fuente primaria-seminegrita texto-xl",
						"es-419": "texto-fuente primaria-seminegrita texto-xl",
						"es-ES": "texto-fuente primaria-seminegrita texto-xl",
						"he": "טקסט-גופן ראשי-חצי מודגש טקסט-XL",
						"it": "testo-carattere primario-semigrassetto testo-xl",
						"pl": "czcionka podstawowa-tekst półpogrubiony-tekst-xl",
						"sw": "maandishi-fonti ya msingi-semibold maandishi-xl",
						"tl": "teksto-pangunahing font-semibold teksto-xl",
						"vi": "văn bản chính phông chữ bán đậm văn bản xl",
						"zh": "文本-​​主字体-半粗体文本-超大"
					},
					"value": "text-primary font-semibold text-xl"
				},
				"href": {
					"translations": {
						"ar": "الهاتف: +19167150890",
						"en": "tel:+19167150890",
						"en-GB": "tel:+19167150890",
						"en-US": "tel:+19167150890",
						"es": "teléfono: +19167150890",
						"es-419": "teléfono: +19167150890",
						"es-ES": "teléfono: +19167150890",
						"he": "טלפון: 19167150890+",
						"it": "tel:+19167150890",
						"pl": "tel.: +19167150890",
						"sw": "simu:+19167150890",
						"tl": "telepono:+19167150890",
						"vi": "Điện thoại: +19167150890",
						"zh": "电话：+19167150890"
					},
					"value": "tel:+19167150890"
				},
				"label": {
					"translations": {
						"ar": "(916) 715-0890",
						"en": "(916) 715-0890",
						"en-GB": "(916) 715-0890",
						"en-US": "(916) 715-0890",
						"es": "(916) 715-0890",
						"es-419": "(916) 715-0890",
						"es-ES": "(916) 715-0890",
						"he": "(916) 715-0890",
						"it": "(916) 715-0890",
						"pl": "(916) 715-0890",
						"sw": "(916) 715-0890",
						"tl": "(916) 715-0890",
						"vi": "(916) 715-0890",
						"zh": "（916）715-0890"
					},
					"value": "(916) 715-0890"
				}
			}
		},
		"Menu 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"hide": {
					"translations": {
						"ar": "userRoles.admin, in, , undefined, false",
						"en": "userRoles.admin, in, , undefined, false",
						"en-GB": "userRoles.admin, in, , undefined, false",
						"en-US": "userRoles.admin, in, , undefined, false",
						"es": "userRoles.admin, en, , indefinido, falso",
						"es-419": "userRoles.admin, en, , indefinido, falso",
						"es-ES": "userRoles.admin, en, , indefinido, falso",
						"he": "userRoles.admin, ב-, , לא מוגדר, שקר",
						"it": "userRoles.admin, in, , indefinito, falso",
						"pl": "userRoles.admin, w, , niezdefiniowane, fałsz",
						"sw": "userRoles.admin, katika, , haijafafanuliwa, si kweli",
						"tl": "userRoles.admin, nasa, , hindi natukoy, mali",
						"vi": "userRoles.admin, trong, , không xác định, false",
						"zh": "userRoles.admin，在，，未定义，false"
					},
					"value": "userRoles.admin, in, , undefined, false"
				},
				"href": {
					"translations": {
						"ar": "/مسؤل/",
						"en": "/admin/",
						"en-GB": "/admin/",
						"en-US": "/admin/",
						"es": "/administración/",
						"es-419": "/administración/",
						"es-ES": "/administración/",
						"he": "/מנהל/",
						"it": "/amministratore/",
						"pl": "/administrator/",
						"sw": "/msimamizi/",
						"tl": "/admin/",
						"vi": "/quản trị viên/",
						"zh": "/行政/"
					},
					"value": "/admin/"
				},
				"label": {
					"translations": {
						"ar": "مسؤل",
						"en": "Admin",
						"en-GB": "Admin",
						"en-US": "Admin",
						"es": "Administración",
						"es-419": "Administración",
						"es-ES": "Administración",
						"he": "מנהל",
						"it": "Amministratore",
						"pl": "Administrator",
						"sw": "Msimamizi",
						"tl": "Admin",
						"vi": "Quản trị viên",
						"zh": "行政"
					},
					"value": "Admin"
				},
				"opStr": {
					"translations": {
						"ar": "src.type, ==, TextObject",
						"en": "src.type, ==, TextObject",
						"en-GB": "src.type, ==, TextObject",
						"en-US": "src.type, ==, TextObject",
						"es": "src.type, ==, Objeto de texto",
						"es-419": "src.type, ==, Objeto de texto",
						"es-ES": "src.type, ==, Objeto de texto",
						"he": "src.type, ==, אובייקט טקסט",
						"it": "src.type, ==, TextObject",
						"pl": "src.type, ==, TextObject",
						"sw": "aina ya src, ==, Kitu cha Maandishi",
						"tl": "src.type, ==, TextObject",
						"vi": "src.type, ==, TextObject",
						"zh": "src.type，==，TextObject"
					},
					"value": "src.type, ==, TextObject"
				},
				"optionHref": {
					"translations": {
						"ar": "اللغة، المنطقة، قيمة مسار المصدر، قيمة نقطة نهاية المصدر",
						"en": "lang, area, src.value.path.value, src.value.endpoint.value",
						"en-GB": "lang, area, src.value.path.value, src.value.endpoint.value",
						"en-US": "lang, area, src.value.path.value, src.value.endpoint.value",
						"es": "lang, área, valor.origen.ruta.valor, valor.origen.punto.final.valor",
						"es-419": "lang, área, valor.origen.ruta.valor, valor.origen.punto.final.valor",
						"es-ES": "lang, área, valor.origen.ruta.valor, valor.origen.punto.final.valor",
						"he": "שפה, אזור, src.value.path.value, src.value.endpoint.value",
						"it": "lingua, area, src.value.path.value, src.value.endpoint.value",
						"pl": "język, obszar, wartość.źródła.ścieżka.wartość, wartość.źródła.punkt.końcowy.wartość",
						"sw": "lugha, eneo, thamani ya njia ya src, thamani ya sehemu ya mwisho ya src",
						"tl": "lang, area, src.value.path.value, src.value.endpoint.value",
						"vi": "lang, area, src.value.path.value, src.value.endpoint.value",
						"zh": "lang、area、src.value.path.value、src.value.endpoint.value"
					},
					"value": "lang, area, src.value.path.value, src.value.endpoint.value"
				},
				"optionLabel": {
					"translations": {
						"ar": "src.value.label",
						"en": "src.value.label",
						"en-GB": "src.value.label",
						"en-US": "src.value.label",
						"es": "src.valor.etiqueta",
						"es-419": "src.valor.etiqueta",
						"es-ES": "src.valor.etiqueta",
						"he": "src.value.label",
						"it": "etichetta.valore.origine",
						"pl": "wartość.źródłowa.etykieta",
						"sw": "lebo ya thamani ya src",
						"tl": "src.value.label",
						"vi": "src.value.label",
						"zh": "src.value.label"
					},
					"value": "src.value.label"
				},
				"optionQuery": {
					"translations": {
						"ar": "src.value.params.value",
						"en": "src.value.params.value",
						"en-GB": "src.value.params.value",
						"en-US": "src.value.params.value",
						"es": "src.value.params.value",
						"es-419": "src.value.params.value",
						"es-ES": "src.value.params.value",
						"he": "src.value.params.value",
						"it": "src.value.params.value",
						"pl": "wartość.źródła.parametry.wartość",
						"sw": "thamani ya src.params.thamani",
						"tl": "src.value.params.value",
						"vi": "src.value.params.value",
						"zh": "src.value.params.value"
					},
					"value": "src.value.params.value"
				},
				"options": {
					"translations": {
						"ar": "الإعدادات، قوائم الإدارة",
						"en": "settings, adminMenus",
						"en-GB": "settings, adminMenus",
						"en-US": "settings, adminMenus",
						"es": "Configuración, adminMenús",
						"es-419": "Configuración, adminMenús",
						"es-ES": "Configuración, adminMenús",
						"he": "הגדרות, מנהלתפריטים",
						"it": "impostazioni, adminMenu",
						"pl": "ustawienia, menu administratora",
						"sw": "mipangilio, Menyu za msimamizi",
						"tl": "mga setting, admin Menu",
						"vi": "cài đặt, menu quản trị",
						"zh": "设置，管理员菜单"
					},
					"value": "settings, adminMenus"
				}
			}
		},
		"Menu 31": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {
						"ar": "مجالات الممارسة",
						"en": "practice areas",
						"en-GB": "practice areas",
						"en-US": "practice areas",
						"es": "áreas de práctica",
						"es-419": "áreas de práctica",
						"es-ES": "áreas de práctica",
						"he": "תחומי עיסוק",
						"it": "aree di pratica",
						"pl": "obszary praktyki",
						"sw": "maeneo ya mazoezi",
						"tl": "mga lugar ng pagsasanay",
						"vi": "các lĩnh vực thực hành",
						"zh": "执业领域"
					},
					"value": "practice areas"
				},
				"cols": {
					"translations": {
						"ar": "مجالات الممارسة والخدمات",
						"en": "practice areas, services",
						"en-GB": "practice areas, services",
						"en-US": "practice areas, services",
						"es": "áreas de práctica, servicios",
						"es-419": "áreas de práctica, servicios",
						"es-ES": "áreas de práctica, servicios",
						"he": "תחומי עיסוק, שירותים",
						"it": "aree di pratica, servizi",
						"pl": "obszary praktyki, usługi",
						"sw": "maeneo ya mazoezi, huduma",
						"tl": "mga lugar ng pagsasanay, mga serbisyo",
						"vi": "các lĩnh vực hành nghề, dịch vụ",
						"zh": "业务领域、服务"
					},
					"value": "practice areas, services"
				},
				"hide": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"href": {
					"translations": {
						"ar": "/مجالات التدريب/",
						"en": "/practice-areas/",
						"en-GB": "/practice-areas/",
						"en-US": "/practice-areas/",
						"es": "/áreas-de-práctica/",
						"es-419": "/áreas-de-práctica/",
						"es-ES": "/áreas-de-práctica/",
						"he": "/תחומי-תרגול/",
						"it": "/aree-di-pratica/",
						"pl": "/obszary-praktyki/",
						"sw": "/maeneo-ya-mazoezi/",
						"tl": "/mga-lugar-ng-pagsasanay/",
						"vi": "/lĩnh vực thực hành/",
						"zh": "/实践领域/"
					},
					"value": "/practice-areas/"
				},
				"label": {
					"translations": {
						"ar": "مجالات الممارسة",
						"en": "Practice Areas",
						"en-GB": "Practice Areas",
						"en-US": "Practice Areas",
						"es": "Áreas de práctica",
						"es-419": "Áreas de práctica",
						"es-ES": "Áreas de práctica",
						"he": "תחומי עיסוק",
						"it": "Aree di competenza",
						"pl": "Obszary praktyki",
						"sw": "Maeneo ya Mazoezi",
						"tl": "Mga Lugar ng Pagsasanay",
						"vi": "Các lĩnh vực thực hành",
						"zh": "业务领域"
					},
					"value": "Practice Areas"
				},
				"optionHref": {
					"translations": {
						"ar": "لانغ، مفتاح",
						"en": "lang, key",
						"en-GB": "lang, key",
						"en-US": "lang, key",
						"es": "idioma, clave",
						"es-419": "idioma, clave",
						"es-ES": "idioma, clave",
						"he": "שפה, מפתח",
						"it": "lingua, chiave",
						"pl": "język, klucz",
						"sw": "lugha, ufunguo",
						"tl": "wika, susi",
						"vi": "lang, key",
						"zh": "语言，关键"
					},
					"value": "lang, key"
				},
				"options": {
					"translations": {
						"ar": "خدمات",
						"en": "services",
						"en-GB": "services",
						"en-US": "services",
						"es": "servicios",
						"es-419": "servicios",
						"es-ES": "servicios",
						"he": "שירותים",
						"it": "servizi",
						"pl": "usługi",
						"sw": "huduma",
						"tl": "mga serbisyo",
						"vi": "dịch vụ",
						"zh": "服务"
					},
					"value": "services"
				}
			}
		},
		"Menu 41": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"col": {
					"translations": {
						"ar": "أخبار",
						"en": "news",
						"en-GB": "news",
						"en-US": "news",
						"es": "noticias",
						"es-419": "noticias",
						"es-ES": "noticias",
						"he": "חֲדָשׁוֹת",
						"it": "notizia",
						"pl": "aktualności",
						"sw": "habari",
						"tl": "balita",
						"vi": "tin tức",
						"zh": "消息"
					},
					"value": "news"
				},
				"cols": {
					"translations": {
						"ar": "أخبار ومقالات",
						"en": "news, articles",
						"en-GB": "news, articles",
						"en-US": "news, articles",
						"es": "noticias, artículos",
						"es-419": "noticias, artículos",
						"es-ES": "noticias, artículos",
						"he": "חדשות, מאמרים",
						"it": "notizie, articoli",
						"pl": "wiadomości, artykuły",
						"sw": "habari, makala",
						"tl": "balita, mga artikulo",
						"vi": "tin tức, bài báo",
						"zh": "新闻、文章"
					},
					"value": "news, articles"
				},
				"hide": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"href": {
					"translations": {
						"ar": "/أخبار/",
						"en": "/news/",
						"en-GB": "/news/",
						"en-US": "/news/",
						"es": "/noticias/",
						"es-419": "/noticias/",
						"es-ES": "/noticias/",
						"he": "/חֲדָשׁוֹת/",
						"it": "/notizia/",
						"pl": "/aktualności/",
						"sw": "/habari/",
						"tl": "/balita/",
						"vi": "/tin tức/",
						"zh": "/消息/"
					},
					"value": "/news/"
				},
				"label": {
					"translations": {
						"ar": "أخبار",
						"en": "News",
						"en-GB": "News",
						"en-US": "News",
						"es": "Noticias",
						"es-419": "Noticias",
						"es-ES": "Noticias",
						"he": "חֲדָשׁוֹת",
						"it": "Notizia",
						"pl": "Aktualności",
						"sw": "Habari",
						"tl": "Balita",
						"vi": "Tin tức",
						"zh": "消息"
					},
					"value": "News"
				},
				"optionHref": {
					"translations": {
						"ar": "لانغ، مفتاح",
						"en": "lang, key",
						"en-GB": "lang, key",
						"en-US": "lang, key",
						"es": "idioma, clave",
						"es-419": "idioma, clave",
						"es-ES": "idioma, clave",
						"he": "שפה, מפתח",
						"it": "lingua, chiave",
						"pl": "język, klucz",
						"sw": "lugha, ufunguo",
						"tl": "wika, susi",
						"vi": "lang, key",
						"zh": "语言，关键"
					},
					"value": "lang, key"
				},
				"options": {
					"translations": {
						"ar": "مقالات",
						"en": "articles",
						"en-GB": "articles",
						"en-US": "articles",
						"es": "artículos",
						"es-419": "artículos",
						"es-ES": "artículos",
						"he": "מאמרים",
						"it": "articoli",
						"pl": "artykuły",
						"sw": "makala",
						"tl": "mga artikulo",
						"vi": "bài viết",
						"zh": "文章"
					},
					"value": "articles"
				}
			}
		},
		"banner": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "/"
				}
			}
		},
		"bannerImageDark": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "مكتب المحامية آمبر بيلانتي، وهو اسم شركة محاماة مكتوب باللون الرمادي الفاتح.",
						"en": "The Law Offices of Amber Bellante, a law firm name in light gray text.",
						"en-GB": "The Law Offices of Amber Bellante, a law firm name in light gray text.",
						"en-US": "The Law Offices of Amber Bellante, a law firm name in light gray text.",
						"es": "El bufete de abogados de Amber Bellante, nombre del bufete en texto gris claro.",
						"es-419": "El bufete de abogados de Amber Bellante, nombre del bufete en texto gris claro.",
						"es-ES": "El bufete de abogados de Amber Bellante, nombre del bufete en texto gris claro.",
						"he": "משרד עורכי הדין של אמבר בלנטה, שם של משרד עורכי דין בטקסט אפור בהיר.",
						"it": "Lo studio legale di Amber Bellante, nome dello studio legale in testo grigio chiaro.",
						"pl": "Kancelaria Adwokacka Amber Bellante, nazwa kancelarii prawnej podana w jasnoszarym tekście.",
						"sw": "Ofisi za Sheria za Amber Bellante, jina la kampuni ya sheria lililoandikwa kwa maandishi ya kijivu hafifu.",
						"tl": "Ang Mga Tanggapan ng Batas ni Amber Bellante, isang pangalan ng law firm na nasa mapusyaw na kulay abong teksto.",
						"vi": "Văn phòng luật sư Amber Bellante, tên công ty luật được in bằng chữ màu xám nhạt.",
						"zh": "Amber Bellante 律师事务所，律师事务所名称以浅灰色字体显示。"
					},
					"value": "The Law Offices of Amber Bellante, a law firm name in light gray text."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fsettings%2FHeader%2FbannerImageDark%2FAmber-Logo-800w-sharpened.png?alt=media&token=832b11d6-104c-4f08-b497-1019de39ce90",
				"formattedSize": "49.64 KB",
				"height": 212,
				"name": "Amber-Logo-800w-sharpened.png",
				"path": "uploads/settings/Header/bannerImageDark/Amber-Logo-800w-sharpened.png",
				"query": "?w=640&as=run:0",
				"size": 50831,
				"type": "image/png",
				"updated": "2026-08-09T00:42:33.467Z",
				"width": 800
			}
		},
		"bannerImageLight": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "مكتب المحامية آمبر بيلانتي، وهو اسم شركة محاماة مكتوب باللون الرمادي الفاتح.",
						"en": "The Law Offices of Amber Bellante, a law firm name in light gray text.",
						"en-GB": "The Law Offices of Amber Bellante, a law firm name in light gray text.",
						"en-US": "The Law Offices of Amber Bellante, a law firm name in light gray text.",
						"es": "Las Oficinas Legales de Amber Bellante, un nombre de bufete de abogados en texto gris claro.",
						"es-419": "Las Oficinas Legales de Amber Bellante, un nombre de bufete de abogados en texto gris claro.",
						"es-ES": "Las Oficinas Legales de Amber Bellante, un nombre de bufete de abogados en texto gris claro.",
						"he": "משרד עורכי הדין של אמבר בלנטה, שם של משרד עורכי דין בטקסט אפור בהיר.",
						"it": "Studio legale di Amber Bellante, il nome dello studio legale è scritto in grigio chiaro.",
						"pl": "Kancelaria Adwokacka Amber Bellante, nazwa kancelarii prawnej podana w jasnoszarym tekście.",
						"sw": "Ofisi za Sheria za Amber Bellante, jina la kampuni ya sheria lililoandikwa kwa maandishi ya kijivu hafifu.",
						"tl": "Ang Mga Tanggapan ng Batas ni Amber Bellante, isang pangalan ng law firm na nasa mapusyaw na kulay abong teksto.",
						"vi": "Văn phòng luật sư Amber Bellante, tên công ty luật được in bằng chữ màu xám nhạt.",
						"zh": "Amber Bellante 律师事务所，律师事务所名称以浅灰色字体显示。"
					},
					"value": "The Law Offices of Amber Bellante, a law firm name in light gray text."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fsettings%2FHeader%2FbannerImageLight%2FAmber-Logo-800w-sharpened.png?alt=media&token=8011cb64-ae1b-49ee-b643-60c6d3d54572",
				"formattedSize": "49.74 KB",
				"height": 212,
				"name": "Amber-Logo-800w-sharpened.png",
				"path": "uploads/settings/Header/bannerImageLight/Amber-Logo-800w-sharpened.png",
				"query": "?w=640&as=run:0",
				"size": 50933,
				"type": "image/png",
				"updated": "2026-03-01T14:15:28.352Z",
				"width": 800
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bannerClass": {
					"translations": {},
					"value": "cursor-pointer inline-block my-auto relative w-60 py-4 px-12"
				},
				"bannerImageClass": {
					"translations": {},
					"value": "relative w-36"
				},
				"bannerLayers": {
					"translations": {},
					"value": "absolute w-full h-full border-2 border-transparent bg-linear-to-r from-[#c0a45c] via-[#ffe7a4] to-[#c0a45c] left-1 -top-1, absolute w-full h-full border-2 border-transparent bg-linear-to-r from-[#c0a45c] via-[#ffe7a4] to-[#c0a45c] -left-1 top-1"
				},
				"menuClasses": {
					"translations": {},
					"value": "text-xl text-primary font-semibold"
				}
			}
		},
		"index": 4,
		"showWeather": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		},
		"styles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bannerLayers": {
					"translations": {},
					"value": "mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;, mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;"
				}
			}
		}
	},
	"adminMenus": {
		"Menu 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "بيت",
						"en": "Home",
						"en-GB": "Home",
						"en-US": "Home",
						"es": "Hogar",
						"es-419": "Hogar",
						"es-ES": "Hogar",
						"he": "בַּיִת",
						"it": "Casa",
						"pl": "Dom",
						"sw": "Nyumbani",
						"tl": "Tahanan",
						"vi": "Trang chủ",
						"zh": "家"
					},
					"value": "Home"
				},
				"params": {
					"translations": {
						"ar": "col=home",
						"en": "col=home",
						"en-GB": "col=home",
						"en-US": "col=home",
						"es": "col=inicio",
						"es-419": "col=inicio",
						"es-ES": "col=inicio",
						"he": "col=בית",
						"it": "col=casa",
						"pl": "col=home",
						"sw": "kol=nyumbani",
						"tl": "col=tahanan",
						"vi": "col=home",
						"zh": "col=首页"
					},
					"value": "col=home"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "مجالات الممارسة",
						"en": "Practice Areas",
						"en-GB": "Practice Areas",
						"en-US": "Practice Areas",
						"es": "Áreas de práctica",
						"es-419": "Áreas de práctica",
						"es-ES": "Áreas de práctica",
						"he": "תחומי עיסוק",
						"it": "Aree di competenza",
						"pl": "Obszary praktyki",
						"sw": "Maeneo ya Mazoezi",
						"tl": "Mga Lugar ng Pagsasanay",
						"vi": "Các lĩnh vực thực hành",
						"zh": "业务领域"
					},
					"value": "Practice Areas"
				},
				"params": {
					"translations": {
						"ar": "col=مناطق التدريب",
						"en": "col=practice areas",
						"en-GB": "col=practice areas",
						"en-US": "col=practice areas",
						"es": "col=áreas de práctica",
						"es-419": "col=áreas de práctica",
						"es-ES": "col=áreas de práctica",
						"he": "תחומי עיסוק",
						"it": "col=aree di pratica",
						"pl": "col=obszary praktyki",
						"sw": "col=maeneo ya mazoezi",
						"tl": "col=mga lugar ng pagsasanay",
						"vi": "cột = khu vực thực hành",
						"zh": "列=实践领域"
					},
					"value": "col=practice areas"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "خدمات",
						"en": "Services",
						"en-GB": "Services",
						"en-US": "Services",
						"es": "Servicios",
						"es-419": "Servicios",
						"es-ES": "Servicios",
						"he": "שירותים",
						"it": "Servizi",
						"pl": "Usługi",
						"sw": "Huduma",
						"tl": "Mga Serbisyo",
						"vi": "Dịch vụ",
						"zh": "服务"
					},
					"value": "Services"
				},
				"params": {
					"translations": {
						"ar": "col=services",
						"en": "col=services",
						"en-GB": "col=services",
						"en-US": "col=services",
						"es": "col=servicios",
						"es-419": "col=servicios",
						"es-ES": "col=servicios",
						"he": "שירותים=col",
						"it": "col=servizi",
						"pl": "col=usługi",
						"sw": "col=huduma",
						"tl": "col=mga serbisyo",
						"vi": "cột = dịch vụ",
						"zh": "列=服务"
					},
					"value": "col=services"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "أخبار",
						"en": "News",
						"en-GB": "News",
						"en-US": "News",
						"es": "Noticias",
						"es-419": "Noticias",
						"es-ES": "Noticias",
						"he": "חֲדָשׁוֹת",
						"it": "Notizia",
						"pl": "Aktualności",
						"sw": "Habari",
						"tl": "Balita",
						"vi": "Tin tức",
						"zh": "消息"
					},
					"value": "News"
				},
				"params": {
					"translations": {
						"ar": "col=news",
						"en": "col=news",
						"en-GB": "col=news",
						"en-US": "col=news",
						"es": "col=noticias",
						"es-419": "col=noticias",
						"es-ES": "col=noticias",
						"he": "חדשות",
						"it": "col=notizie",
						"pl": "col=news",
						"sw": "kol=habari",
						"tl": "col=balita",
						"vi": "col=news",
						"zh": "col=新闻"
					},
					"value": "col=news"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 07": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "مقالات",
						"en": "Articles",
						"en-GB": "Articles",
						"en-US": "Articles",
						"es": "Artículos",
						"es-419": "Artículos",
						"es-ES": "Artículos",
						"he": "מאמרים",
						"it": "Articoli",
						"pl": "Artykuły",
						"sw": "Makala",
						"tl": "Mga Artikulo",
						"vi": "Bài viết",
						"zh": "文章"
					},
					"value": "Articles"
				},
				"params": {
					"translations": {
						"ar": "col=articles",
						"en": "col=articles",
						"en-GB": "col=articles",
						"en-US": "col=articles",
						"es": "col=artículos",
						"es-419": "col=artículos",
						"es-ES": "col=artículos",
						"he": "מאמרים=עמודות",
						"it": "col=articoli",
						"pl": "col=artykuły",
						"sw": "kol=makala",
						"tl": "col=mga artikulo",
						"vi": "cột=bài viết",
						"zh": "col=文章"
					},
					"value": "col=articles"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 08": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "عن",
						"en": "About",
						"en-GB": "About",
						"en-US": "About",
						"es": "Acerca de",
						"es-419": "Acerca de",
						"es-ES": "Acerca de",
						"he": "אוֹדוֹת",
						"it": "Di",
						"pl": "O",
						"sw": "Kuhusu",
						"tl": "Tungkol sa",
						"vi": "Về",
						"zh": "关于"
					},
					"value": "About"
				},
				"params": {
					"translations": {
						"ar": "col=about",
						"en": "col=about",
						"en-GB": "col=about",
						"en-US": "col=about",
						"es": "col=acerca de",
						"es-419": "col=acerca de",
						"es-ES": "col=acerca de",
						"he": "קול=אודות",
						"it": "col=circa",
						"pl": "col=o",
						"sw": "kol=kuhusu",
						"tl": "col=tungkol sa",
						"vi": "col=về",
						"zh": "col=关于"
					},
					"value": "col=about"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 09": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "مواقعنا",
						"en": "Our Locations",
						"en-GB": "Our Locations",
						"en-US": "Our Locations",
						"es": "Nuestras ubicaciones",
						"es-419": "Nuestras ubicaciones",
						"es-ES": "Nuestras ubicaciones",
						"he": "המיקומים שלנו",
						"it": "Le nostre sedi",
						"pl": "Nasze lokalizacje",
						"sw": "Maeneo Yetu",
						"tl": "Ang Aming mga Lokasyon",
						"vi": "Địa điểm của chúng tôi",
						"zh": "我们的位置"
					},
					"value": "Our Locations"
				},
				"params": {
					"translations": {
						"ar": "col=مواقعنا",
						"en": "col=our locations",
						"en-GB": "col=our locations",
						"en-US": "col=our locations",
						"es": "col=nuestras ubicaciones",
						"es-419": "col=nuestras ubicaciones",
						"es-ES": "col=nuestras ubicaciones",
						"he": "צבע=המיקומים שלנו",
						"it": "col=le nostre posizioni",
						"pl": "col=nasze lokalizacje",
						"sw": "col=maeneo yetu",
						"tl": "kulay=aming mga lokasyon",
						"vi": "màu sắc = vị trí của chúng tôi",
						"zh": "col=我们的地点"
					},
					"value": "col=our locations"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 11": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "المواقع",
						"en": "Locations",
						"en-GB": "Locations",
						"en-US": "Locations",
						"es": "Ubicaciones",
						"es-419": "Ubicaciones",
						"es-ES": "Ubicaciones",
						"he": "מיקומים",
						"it": "Posizioni",
						"pl": "Lokalizacje",
						"sw": "Maeneo",
						"tl": "Mga Lokasyon",
						"vi": "Địa điểm",
						"zh": "地点"
					},
					"value": "Locations"
				},
				"params": {
					"translations": {
						"ar": "col=locations",
						"en": "col=locations",
						"en-GB": "col=locations",
						"en-US": "col=locations",
						"es": "col=ubicaciones",
						"es-419": "col=ubicaciones",
						"es-ES": "col=ubicaciones",
						"he": "col=locations",
						"it": "col=posizioni",
						"pl": "col=locations",
						"sw": "kol=maeneo",
						"tl": "col=mga lokasyon",
						"vi": "col=locations",
						"zh": "列=位置"
					},
					"value": "col=locations"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 12": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "اتصال",
						"en": "Contact",
						"en-GB": "Contact",
						"en-US": "Contact",
						"es": "Contacto",
						"es-419": "Contacto",
						"es-ES": "Contacto",
						"he": "מַגָע",
						"it": "Contatto",
						"pl": "Kontakt",
						"sw": "Mawasiliano",
						"tl": "Makipag-ugnayan",
						"vi": "Liên hệ",
						"zh": "接触"
					},
					"value": "Contact"
				},
				"params": {
					"translations": {
						"ar": "col=اتصل بنا",
						"en": "col=contact us",
						"en-GB": "col=contact us",
						"en-US": "col=contact us",
						"es": "col=contáctanos",
						"es-419": "col=contáctanos",
						"es-ES": "col=contáctanos",
						"he": "צור קשר",
						"it": "col=contattaci",
						"pl": "col=skontaktuj się z nami",
						"sw": "col=wasiliana nasi",
						"tl": "col=makipag-ugnayan sa amin",
						"vi": "col=liên hệ với chúng tôi",
						"zh": "联系我们"
					},
					"value": "col=contact us"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "إعدادات",
						"en": "Settings",
						"en-GB": "Settings",
						"en-US": "Settings",
						"es": "Ajustes",
						"es-419": "Ajustes",
						"es-ES": "Ajustes",
						"he": "הגדרות",
						"it": "Impostazioni",
						"pl": "Ustawienia",
						"sw": "Mipangilio",
						"tl": "Mga Setting",
						"vi": "Cài đặt",
						"zh": "设置"
					},
					"value": "Settings"
				},
				"params": {
					"translations": {
						"ar": "col=settings",
						"en": "col=settings",
						"en-GB": "col=settings",
						"en-US": "col=settings",
						"es": "col=configuraciones",
						"es-419": "col=configuraciones",
						"es-ES": "col=configuraciones",
						"he": "col=הגדרות",
						"it": "col=impostazioni",
						"pl": "col=ustawienia",
						"sw": "kol=mipangilio",
						"tl": "col=mga setting",
						"vi": "cột=cài đặt",
						"zh": "列=设置"
					},
					"value": "col=settings"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 22": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {
						"ar": "العمليات",
						"en": "operations",
						"en-GB": "operations",
						"en-US": "operations",
						"es": "operaciones",
						"es-419": "operaciones",
						"es-ES": "operaciones",
						"he": "פעולות",
						"it": "operazioni",
						"pl": "operacje",
						"sw": "shughuli",
						"tl": "mga operasyon",
						"vi": "hoạt động",
						"zh": "运营"
					},
					"value": "operations"
				},
				"label": {
					"translations": {
						"ar": "العمليات",
						"en": "Operations",
						"en-GB": "Operations",
						"en-US": "Operations",
						"es": "Operaciones",
						"es-419": "Operaciones",
						"es-ES": "Operaciones",
						"he": "פעולות",
						"it": "Operazioni",
						"pl": "Operacje",
						"sw": "Operesheni",
						"tl": "Mga Operasyon",
						"vi": "Hoạt động",
						"zh": "运营"
					},
					"value": "Operations"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 23": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {
						"ar": "المشاركات",
						"en": "submissions",
						"en-GB": "submissions",
						"en-US": "submissions",
						"es": "presentaciones",
						"es-419": "presentaciones",
						"es-ES": "presentaciones",
						"he": "הגשות",
						"it": "proposte",
						"pl": "zgłoszenia",
						"sw": "mawasilisho",
						"tl": "mga pagsusumite",
						"vi": "bài nộp",
						"zh": "提交"
					},
					"value": "submissions"
				},
				"label": {
					"translations": {
						"ar": "المشاركات",
						"en": "Submissions",
						"en-GB": "Submissions",
						"en-US": "Submissions",
						"es": "Envíos",
						"es-419": "Envíos",
						"es-ES": "Envíos",
						"he": "הגשות",
						"it": "Invii",
						"pl": "Zgłoszenia",
						"sw": "Mawasilisho",
						"tl": "Mga Pagsusumite",
						"vi": "Bài nộp",
						"zh": "提交"
					},
					"value": "Submissions"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 24": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {
						"ar": "إدارة الحالات",
						"en": "case-management",
						"en-GB": "case-management",
						"en-US": "case-management",
						"es": "gestión de casos",
						"es-419": "gestión de casos",
						"es-ES": "gestión de casos",
						"he": "ניהול תיקים",
						"it": "gestione dei casi",
						"pl": "zarządzanie sprawami",
						"sw": "usimamizi wa kesi",
						"tl": "pamamahala ng kaso",
						"vi": "quản lý trường hợp",
						"zh": "个案管理"
					},
					"value": "case-management"
				},
				"label": {
					"translations": {
						"ar": "إدارة الحالات",
						"en": "Case Management",
						"en-GB": "Case Management",
						"en-US": "Case Management",
						"es": "Gestión de casos",
						"es-419": "Gestión de casos",
						"es-ES": "Gestión de casos",
						"he": "ניהול תיקים",
						"it": "Gestione dei casi",
						"pl": "Zarządzanie sprawami",
						"sw": "Usimamizi wa Kesi",
						"tl": "Pamamahala ng Kaso",
						"vi": "Quản lý trường hợp",
						"zh": "个案管理"
					},
					"value": "Case Management"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 25": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {
						"ar": "الأدوار",
						"en": "roles",
						"en-GB": "roles",
						"en-US": "roles",
						"es": "roles",
						"es-419": "roles",
						"es-ES": "roles",
						"he": "תפקידים",
						"it": "ruoli",
						"pl": "role",
						"sw": "majukumu",
						"tl": "mga tungkulin",
						"vi": "vai trò",
						"zh": "角色"
					},
					"value": "roles"
				},
				"label": {
					"translations": {
						"ar": "الأدوار",
						"en": "Roles",
						"en-GB": "Roles",
						"en-US": "Roles",
						"es": "Roles",
						"es-419": "Roles",
						"es-ES": "Roles",
						"he": "תפקידים",
						"it": "Ruoli",
						"pl": "Role",
						"sw": "Majukumu",
						"tl": "Mga Tungkulin",
						"vi": "Vai trò",
						"zh": "角色"
					},
					"value": "Roles"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 26": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"endpoint": {
					"translations": {
						"ar": "إعدادات التطبيق",
						"en": "appsettings",
						"en-GB": "appsettings",
						"en-US": "appsettings",
						"es": "ajustes de la aplicación",
						"es-419": "ajustes de la aplicación",
						"es-ES": "ajustes de la aplicación",
						"he": "הגדרות אפליקציה",
						"it": "impostazioni dell'app",
						"pl": "ustawienia aplikacji",
						"sw": "mipangilio ya programu",
						"tl": "mga setting ng app",
						"vi": "cài đặt ứng dụng",
						"zh": "应用设置"
					},
					"value": "appsettings"
				},
				"label": {
					"translations": {
						"ar": "إعدادات التطبيق",
						"en": "App Settings",
						"en-GB": "App Settings",
						"en-US": "App Settings",
						"es": "Configuración de la aplicación",
						"es-419": "Configuración de la aplicación",
						"es-ES": "Configuración de la aplicación",
						"he": "הגדרות אפליקציה",
						"it": "Impostazioni dell'app",
						"pl": "Ustawienia aplikacji",
						"sw": "Mipangilio ya Programu",
						"tl": "Mga Setting ng App",
						"vi": "Cài đặt ứng dụng",
						"zh": "应用设置"
					},
					"value": "App Settings"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"Menu 27": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "تسجيل الخروج",
						"en": "Logout",
						"en-GB": "Logout",
						"en-US": "Logout",
						"es": "Cerrar sesión",
						"es-419": "Cerrar sesión",
						"es-ES": "Cerrar sesión",
						"he": "התנתק",
						"it": "Esci",
						"pl": "Wyloguj",
						"sw": "Toka",
						"tl": "Mag-logout",
						"vi": "Đăng xuất",
						"zh": "注销"
					},
					"value": "Logout"
				},
				"path": {
					"translations": {
						"ar": "مسؤل",
						"en": "admin",
						"en-GB": "admin",
						"en-US": "admin",
						"es": "administración",
						"es-419": "administración",
						"es-ES": "administración",
						"he": "מנהל",
						"it": "amministratore",
						"pl": "administrator",
						"sw": "msimamizi",
						"tl": "admin",
						"vi": "quản trị viên",
						"zh": "行政"
					},
					"value": "admin"
				}
			}
		},
		"index": 5
	},
	"languages": {
		"Language 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "en",
						"en": "en",
						"en-GB": "en",
						"en-US": "en",
						"es": "en",
						"es-419": "en",
						"es-ES": "en",
						"he": "en",
						"it": "esso",
						"pl": "pl",
						"sw": "sw",
						"tl": "en",
						"vi": "en",
						"zh": "英文"
					},
					"value": "en"
				},
				"label": {
					"translations": {
						"ar": "إنجليزي",
						"en": "English",
						"en-GB": "English",
						"en-US": "English",
						"es": "Inglés",
						"es-419": "Inglés",
						"es-ES": "Inglés",
						"he": "אַנגְלִית",
						"it": "Inglese",
						"pl": "angielski",
						"sw": "Kiingereza",
						"tl": "Ingles",
						"vi": "Tiếng Anh",
						"zh": "英语"
					},
					"value": "English"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇺🇸/🇬🇧",
						"en": "🇺🇸/🇬🇧",
						"en-GB": "🇺🇸/🇬🇧",
						"en-US": "🇺🇸/🇬🇧",
						"es": "🇺🇸/🇬🇧",
						"es-419": "🇺🇸/🇬🇧",
						"es-ES": "🇺🇸/🇬🇧",
						"he": "🇺🇸/🇬🇧",
						"it": "🇺🇸/🇬🇧",
						"pl": "🇺🇸/🇬🇧",
						"sw": "🇺🇸/🇬🇧",
						"tl": "🇺🇸/🇬🇧",
						"vi": "🇺🇸/🇬🇧",
						"zh": "🇺🇸/🇬🇧"
					},
					"value": "🇺🇸/🇬🇧"
				}
			}
		},
		"Language 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "en-US",
						"en": "en-US",
						"en-GB": "en-US",
						"en-US": "en-US",
						"es": "en-US",
						"es-419": "en-US",
						"es-ES": "en-US",
						"he": "en-US",
						"it": "en-US",
						"pl": "en-US",
						"sw": "en-US",
						"tl": "en-US",
						"vi": "en-US",
						"zh": "美国英语"
					},
					"value": "en-US"
				},
				"default": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"label": {
					"translations": {
						"ar": "الإنجليزية (الولايات المتحدة)",
						"en": "English (United States)",
						"en-GB": "English (United States)",
						"en-US": "English (United States)",
						"es": "Inglés (Estados Unidos)",
						"es-419": "Inglés (Estados Unidos)",
						"es-ES": "Inglés (Estados Unidos)",
						"he": "אנגלית (ארצות הברית)",
						"it": "Inglese (Stati Uniti)",
						"pl": "Angielski (Stany Zjednoczone)",
						"sw": "Kiingereza (Marekani)",
						"tl": "Ingles (Estados Unidos)",
						"vi": "Tiếng Anh (Hoa Kỳ)",
						"zh": "英语（美国）"
					},
					"value": "English (United States)"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇺🇸",
						"en": "🇺🇸",
						"en-GB": "🇺🇸",
						"en-US": "🇺🇸",
						"es": "🇺🇸",
						"es-419": "🇺🇸",
						"es-ES": "🇺🇸",
						"he": "🇺🇸",
						"it": "🇺🇸",
						"pl": "🇺🇸",
						"sw": "🇺🇸",
						"tl": "🇺🇸",
						"vi": "🇺🇸",
						"zh": "🇺🇸"
					},
					"value": "🇺🇸"
				}
			}
		},
		"Language 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "en-GB",
						"en": "en-GB",
						"en-GB": "en-GB",
						"en-US": "en-GB",
						"es": "es-GB",
						"es-419": "es-GB",
						"es-ES": "es-GB",
						"he": "en-GB",
						"it": "en-GB",
						"pl": "en-GB",
						"sw": "en-GB",
						"tl": "en-GB",
						"vi": "en-GB",
						"zh": "英国"
					},
					"value": "en-GB"
				},
				"label": {
					"translations": {
						"ar": "إنجليزي",
						"en": "English",
						"en-GB": "English",
						"en-US": "English",
						"es": "Inglés",
						"es-419": "Inglés",
						"es-ES": "Inglés",
						"he": "אַנגְלִית",
						"it": "Inglese",
						"pl": "angielski",
						"sw": "Kiingereza",
						"tl": "Ingles",
						"vi": "Tiếng Anh",
						"zh": "英语"
					},
					"value": "English"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇬🇧",
						"en": "🇬🇧",
						"en-GB": "🇬🇧",
						"en-US": "🇬🇧",
						"es": "🇪🇸",
						"es-419": "🇪🇸",
						"es-ES": "🇪🇸",
						"he": "🇬🇧",
						"it": "🇬🇧",
						"pl": "🇬🇧",
						"sw": "🇬🇧",
						"tl": "🇬🇧",
						"vi": "🇬🇧",
						"zh": "🇬🇧"
					},
					"value": "🇬🇧"
				}
			}
		},
		"Language 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "es",
						"en": "es",
						"en-GB": "es",
						"en-US": "es",
						"es": "es",
						"es-419": "es",
						"es-ES": "es",
						"he": "es",
						"it": "es",
						"pl": "es",
						"sw": "es",
						"tl": "es",
						"vi": "es",
						"zh": "es"
					},
					"value": "es"
				},
				"label": {
					"translations": {
						"ar": "الأسبانية",
						"en": "Spanish",
						"en-GB": "Spanish",
						"en-US": "Spanish",
						"es": "Español",
						"es-419": "Español",
						"es-ES": "Español",
						"he": "סְפָרַדִית",
						"it": "spagnolo",
						"pl": "hiszpański",
						"sw": "Kihispania",
						"tl": "Espanyol",
						"vi": "tiếng Tây Ban Nha",
						"zh": "西班牙语"
					},
					"value": "Spanish"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇲🇽/🇪🇸",
						"en": "🇲🇽/🇪🇸",
						"en-GB": "🇲🇽/🇪🇸",
						"en-US": "🇲🇽/🇪🇸",
						"es": "🇲🇽/🇪🇸",
						"es-419": "🇲🇽/🇪🇸",
						"es-ES": "🇲🇽/🇪🇸",
						"he": "🇲🇽/🇪🇸",
						"it": "🇲🇽/🇪🇸",
						"pl": "🇲🇽/🇪🇸",
						"sw": "🇲🇽/🇪🇸",
						"tl": "🇲🇽/🇪🇸",
						"vi": "🇲🇽/🇪🇸",
						"zh": "🇲🇽/🇪🇸"
					},
					"value": "🇲🇽/🇪🇸"
				}
			}
		},
		"Language 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "es-ES",
						"en": "es-ES",
						"en-GB": "es-ES",
						"en-US": "es-ES",
						"es": "es-ES",
						"es-419": "es-ES",
						"es-ES": "es-ES",
						"he": "es-ES",
						"it": "es-ES",
						"pl": "es-ES",
						"sw": "es-ES",
						"tl": "es-ES",
						"vi": "es-ES",
						"zh": "es-ES"
					},
					"value": "es-ES"
				},
				"label": {
					"translations": {
						"ar": "الإسبانية",
						"en": "Español",
						"en-GB": "Español",
						"en-US": "Español",
						"es": "Español",
						"es-419": "Español",
						"es-ES": "Español",
						"he": "ספרדית",
						"it": "Spagnolo",
						"pl": "hiszpański",
						"sw": "Kihispania",
						"tl": "Espanyol",
						"vi": "Tiếng Tây Ban Nha",
						"zh": "西班牙语"
					},
					"value": "Español"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇪🇸",
						"en": "🇪🇸",
						"en-GB": "🇪🇸",
						"en-US": "🇪🇸",
						"es": "🇪🇸",
						"es-419": "🇪🇸",
						"es-ES": "🇪🇸",
						"he": "🇪🇸",
						"it": "🇪🇸",
						"pl": "🇪🇸",
						"sw": "🇪🇸",
						"tl": "🇪🇸",
						"vi": "🇪🇸",
						"zh": "🇪🇸"
					},
					"value": "🇪🇸"
				}
			}
		},
		"Language 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "es-419",
						"en": "es-419",
						"en-GB": "es-419",
						"en-US": "es-419",
						"es": "es-419",
						"es-419": "es-419",
						"es-ES": "es-419",
						"he": "es-419",
						"it": "es-419",
						"pl": "es-419",
						"sw": "es-419",
						"tl": "es-419",
						"vi": "es-419",
						"zh": "es-419"
					},
					"value": "es-419"
				},
				"label": {
					"translations": {
						"ar": "الإسبانية (أمريكا اللاتينية)",
						"en": "Spanish (Latin America)",
						"en-GB": "Spanish (Latin America)",
						"en-US": "Spanish (Latin America)",
						"es": "Español (América Latina)",
						"es-419": "Español (América Latina)",
						"es-ES": "Español (América Latina)",
						"he": "ספרדית (אמריקה הלטינית)",
						"it": "spagnolo (America Latina)",
						"pl": "hiszpański (Ameryka Łacińska)",
						"sw": "Kihispania (Amerika ya Kilatini)",
						"tl": "Espanyol (Latin America)",
						"vi": "Tiếng Tây Ban Nha (Mỹ Latinh)",
						"zh": "西班牙语（拉丁美洲）"
					},
					"value": "Spanish (Latin America)"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇲🇽",
						"en": "🇲🇽",
						"en-GB": "🇲🇽",
						"en-US": "🇲🇽",
						"es": "🇲🇽",
						"es-419": "🇲🇽",
						"es-ES": "🇲🇽",
						"he": "🇲🇽",
						"it": "🇲🇽",
						"pl": "🇲🇽",
						"sw": "🇲🇽",
						"tl": "🇲🇽",
						"vi": "🇲🇽",
						"zh": "🇲🇽"
					},
					"value": "🇲🇽"
				}
			}
		},
		"Language 07": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "zh",
						"en": "zh",
						"en-GB": "zh",
						"en-US": "zh",
						"es": "zh",
						"es-419": "zh",
						"es-ES": "zh",
						"he": "ז'",
						"it": "zh",
						"pl": "zh",
						"sw": "zh",
						"tl": "zh",
						"vi": "zh",
						"zh": "zh"
					},
					"value": "zh"
				},
				"label": {
					"translations": {
						"ar": "الصينية",
						"en": "Chinese",
						"en-GB": "Chinese",
						"en-US": "Chinese",
						"es": "Chino",
						"es-419": "Chino",
						"es-ES": "Chino",
						"he": "סִינִית",
						"it": "cinese",
						"pl": "chiński",
						"sw": "Kichina",
						"tl": "Tsino",
						"vi": "Trung Quốc",
						"zh": "中国人"
					},
					"value": "Chinese"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇨🇳",
						"en": "🇨🇳",
						"en-GB": "🇨🇳",
						"en-US": "🇨🇳",
						"es": "🇨🇳",
						"es-419": "🇨🇳",
						"es-ES": "🇨🇳",
						"he": "🇨🇳",
						"it": "🇨🇳",
						"pl": "🇨🇳",
						"sw": "🇨🇳",
						"tl": "🇨🇳",
						"vi": "🇨🇳",
						"zh": "🇨🇳"
					},
					"value": "🇨🇳"
				}
			}
		},
		"Language 08": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "جنوب غرب",
						"en": "sw",
						"en-GB": "sw",
						"en-US": "sw",
						"es": "sudoeste",
						"es-419": "sudoeste",
						"es-ES": "sudoeste",
						"he": "שד",
						"it": "sw",
						"pl": "południowy zachód",
						"sw": "sw",
						"tl": "sw",
						"vi": "sw",
						"zh": "sw"
					},
					"value": "sw"
				},
				"label": {
					"translations": {
						"ar": "السواحيلية",
						"en": "Swahili",
						"en-GB": "Swahili",
						"en-US": "Swahili",
						"es": "swahili",
						"es-419": "swahili",
						"es-ES": "swahili",
						"he": "סוואהילית",
						"it": "Swahili",
						"pl": "suahili",
						"sw": "Kiswahili",
						"tl": "Swahili",
						"vi": "Tiếng Swahili",
						"zh": "斯瓦希里语"
					},
					"value": "Swahili"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇰🇪/🇹🇿",
						"en": "🇰🇪/🇹🇿",
						"en-GB": "🇰🇪/🇹🇿",
						"en-US": "🇰🇪/🇹🇿",
						"es": "🇰🇪/🇹🇿",
						"es-419": "🇰🇪/🇹🇿",
						"es-ES": "🇰🇪/🇹🇿",
						"he": "🇰🇪/🇹🇿",
						"it": "🇰🇪/🇹🇿",
						"pl": "🇰🇪/🇹🇿",
						"sw": "🇰🇪/🇹🇿",
						"tl": "🇰🇪/🇹🇿",
						"vi": "🇰🇪/🇹🇿",
						"zh": "🇰🇪/🇹🇿"
					},
					"value": "🇰🇪/🇹🇿"
				}
			}
		},
		"Language 09": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "tl",
						"en": "tl",
						"en-GB": "tl",
						"en-US": "tl",
						"es": "tl",
						"es-419": "tl",
						"es-ES": "tl",
						"he": "טל",
						"it": "in breve",
						"pl": "tl",
						"sw": "tl",
						"tl": "tl",
						"vi": "tl",
						"zh": "tl"
					},
					"value": "tl"
				},
				"dir": {
					"translations": {
						"ar": "حرف",
						"en": "ltr",
						"en-GB": "ltr",
						"en-US": "ltr",
						"es": "ltr",
						"es-419": "ltr",
						"es-ES": "ltr",
						"he": "ליטר",
						"it": "litri",
						"pl": "ltr",
						"sw": "ltr",
						"tl": "litro",
						"vi": "thư",
						"zh": "升"
					},
					"value": "ltr"
				},
				"label": {
					"translations": {
						"ar": "التاغالوغية",
						"en": "Tagalog",
						"en-GB": "Tagalog",
						"en-US": "Tagalog",
						"es": "Tagalo",
						"es-419": "Tagalo",
						"es-ES": "Tagalo",
						"he": "טגלוג",
						"it": "Tagalog",
						"pl": "Tagalski",
						"sw": "Kitagalogi",
						"tl": "Tagalog",
						"vi": "Tiếng Tagalog",
						"zh": "他加禄语"
					},
					"value": "Tagalog"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇵🇭",
						"en": "🇵🇭",
						"en-GB": "🇵🇭",
						"en-US": "🇵🇭",
						"es": "🇵🇭",
						"es-419": "🇵🇭",
						"es-ES": "🇵🇭",
						"he": "🇵🇭",
						"it": "🇵🇭",
						"pl": "🇵🇭",
						"sw": "🇵🇭",
						"tl": "🇵🇭",
						"vi": "🇵🇭",
						"zh": "🇵🇭"
					},
					"value": "🇵🇭"
				}
			}
		},
		"Language 10": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "vi",
						"en": "vi",
						"en-GB": "vi",
						"en-US": "vi",
						"es": "vi",
						"es-419": "vi",
						"es-ES": "vi",
						"he": "וי",
						"it": "vi",
						"pl": "vi",
						"sw": "vi",
						"tl": "vi",
						"vi": "vi",
						"zh": "六"
					},
					"value": "vi"
				},
				"dir": {
					"translations": {
						"ar": "حرف",
						"en": "ltr",
						"en-GB": "ltr",
						"en-US": "ltr",
						"es": "ltr",
						"es-419": "ltr",
						"es-ES": "ltr",
						"he": "ליטר",
						"it": "litri",
						"pl": "ltr",
						"sw": "ltr",
						"tl": "litro",
						"vi": "thư",
						"zh": "升"
					},
					"value": "ltr"
				},
				"label": {
					"translations": {
						"ar": "الفيتناميين",
						"en": "Vietnamese",
						"en-GB": "Vietnamese",
						"en-US": "Vietnamese",
						"es": "vietnamita",
						"es-419": "vietnamita",
						"es-ES": "vietnamita",
						"he": "וייטנאמית",
						"it": "vietnamita",
						"pl": "wietnamski",
						"sw": "Kivietnam",
						"tl": "Vietnamese",
						"vi": "Tiếng Việt",
						"zh": "越南语"
					},
					"value": "Vietnamese"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇻🇳",
						"en": "🇻🇳",
						"en-GB": "🇻🇳",
						"en-US": "🇻🇳",
						"es": "🇻🇳",
						"es-419": "🇻🇳",
						"es-ES": "🇻🇳",
						"he": "🇻🇳",
						"it": "🇻🇳",
						"pl": "🇻🇳",
						"sw": "🇻🇳",
						"tl": "🇻🇳",
						"vi": "🇻🇳",
						"zh": "🇻🇳"
					},
					"value": "🇻🇳"
				}
			}
		},
		"Language 11": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "ar",
						"en": "ar",
						"en-GB": "ar",
						"en-US": "ar",
						"es": "Arkansas",
						"es-419": "Arkansas",
						"es-ES": "Arkansas",
						"he": "אר",
						"it": "esso",
						"pl": "ar",
						"sw": "ar",
						"tl": "ar",
						"vi": "ar",
						"zh": "ar"
					},
					"value": "ar"
				},
				"dir": {
					"translations": {
						"ar": "من اليمين إلى اليسار",
						"en": "rtl",
						"en-GB": "rtl",
						"en-US": "rtl",
						"es": "derecho",
						"es-419": "derecho",
						"es-ES": "derecho",
						"he": "rtl",
						"it": "rtl",
						"pl": "rtl",
						"sw": "rtl",
						"tl": "rtl",
						"vi": "rtl",
						"zh": "右翼"
					},
					"value": "rtl"
				},
				"label": {
					"translations": {
						"ar": "عربي",
						"en": "Arabic",
						"en-GB": "Arabic",
						"en-US": "Arabic",
						"es": "árabe",
						"es-419": "árabe",
						"es-ES": "árabe",
						"he": "עֲרָבִית",
						"it": "arabo",
						"pl": "arabski",
						"sw": "Kiarabu",
						"tl": "Arabe",
						"vi": "tiếng Ả Rập",
						"zh": "阿拉伯"
					},
					"value": "Arabic"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇸🇦",
						"en": "🇸🇦",
						"en-GB": "🇸🇦",
						"en-US": "🇸🇦",
						"es": "🇸🇦",
						"es-419": "🇸🇦",
						"es-ES": "🇸🇦",
						"he": "🇸🇦",
						"it": "🇸🇦",
						"pl": "🇸🇦",
						"sw": "🇸🇦",
						"tl": "🇸🇦",
						"vi": "🇸🇦",
						"zh": "🇸🇦"
					},
					"value": "🇸🇦"
				}
			}
		},
		"Language 12": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "هو",
						"en": "he",
						"en-GB": "he",
						"en-US": "he",
						"es": "él",
						"es-419": "él",
						"es-ES": "él",
						"he": "הוּא",
						"it": "Lui",
						"pl": "On",
						"sw": "yeye",
						"tl": "siya",
						"vi": "Anh ta",
						"zh": "他"
					},
					"value": "he"
				},
				"dir": {
					"translations": {
						"ar": "من اليمين إلى اليسار",
						"en": "rtl",
						"en-GB": "rtl",
						"en-US": "rtl",
						"es": "derecho",
						"es-419": "derecho",
						"es-ES": "derecho",
						"he": "rtl",
						"it": "rtl",
						"pl": "rtl",
						"sw": "rtl",
						"tl": "rtl",
						"vi": "rtl",
						"zh": "右翼"
					},
					"value": "rtl"
				},
				"label": {
					"translations": {
						"ar": "العبرية",
						"en": "Hebrew",
						"en-GB": "Hebrew",
						"en-US": "Hebrew",
						"es": "hebreo",
						"es-419": "hebreo",
						"es-ES": "hebreo",
						"he": "עִברִית",
						"it": "ebraico",
						"pl": "hebrajski",
						"sw": "Kiebrania",
						"tl": "Hebreo",
						"vi": "tiếng Do Thái",
						"zh": "希伯来语"
					},
					"value": "Hebrew"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇮🇱",
						"en": "🇮🇱",
						"en-GB": "🇮🇱",
						"en-US": "🇮🇱",
						"es": "🇮🇱",
						"es-419": "🇮🇱",
						"es-ES": "🇮🇱",
						"he": "🇮🇱",
						"it": "🇮🇱",
						"pl": "🇮🇱",
						"sw": "🇮🇱",
						"tl": "🇮🇱",
						"vi": "🇮🇱",
						"zh": "🇮🇱"
					},
					"value": "🇮🇱"
				}
			}
		},
		"Language 13": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "هو - هي",
						"en": "it",
						"en-GB": "it",
						"en-US": "it",
						"es": "él",
						"es-419": "él",
						"es-ES": "él",
						"he": "זֶה",
						"it": "Esso",
						"pl": "To",
						"sw": "hiyo",
						"tl": "ito",
						"vi": "Nó",
						"zh": "它"
					},
					"value": "it"
				},
				"dir": {
					"translations": {
						"ar": "حرف",
						"en": "ltr",
						"en-GB": "ltr",
						"en-US": "ltr",
						"es": "ltr",
						"es-419": "ltr",
						"es-ES": "ltr",
						"he": "ליטר",
						"it": "litri",
						"pl": "ltr",
						"sw": "ltr",
						"tl": "litro",
						"vi": "thư",
						"zh": "升"
					},
					"value": "ltr"
				},
				"label": {
					"translations": {
						"ar": "إيطالي",
						"en": "Italian",
						"en-GB": "Italian",
						"en-US": "Italian",
						"es": "italiano",
						"es-419": "italiano",
						"es-ES": "italiano",
						"he": "אִיטַלְקִית",
						"it": "Italiano",
						"pl": "włoski",
						"sw": "Kiitaliano",
						"tl": "Italyano",
						"vi": "Ý",
						"zh": "意大利语"
					},
					"value": "Italian"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇮🇹",
						"en": "🇮🇹",
						"en-GB": "🇮🇹",
						"en-US": "🇮🇹",
						"es": "🇮🇹",
						"es-419": "🇮🇹",
						"es-ES": "🇮🇹",
						"he": "🇮🇹",
						"it": "🇮🇹",
						"pl": "🇮🇹",
						"sw": "🇮🇹",
						"tl": "🇮🇹",
						"vi": "🇮🇹",
						"zh": "🇮🇹"
					},
					"value": "🇮🇹"
				}
			}
		},
		"Language 14": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"code": {
					"translations": {
						"ar": "pl",
						"en": "pl",
						"en-GB": "pl",
						"en-US": "pl",
						"es": "por favor",
						"es-419": "por favor",
						"es-ES": "por favor",
						"he": "רב",
						"it": "per favore",
						"pl": "proszę",
						"sw": "pl",
						"tl": "pl",
						"vi": "pl",
						"zh": "pl"
					},
					"value": "pl"
				},
				"dir": {
					"translations": {
						"ar": "حرف",
						"en": "ltr",
						"en-GB": "ltr",
						"en-US": "ltr",
						"es": "ltr",
						"es-419": "ltr",
						"es-ES": "ltr",
						"he": "ליטר",
						"it": "litri",
						"pl": "ltr",
						"sw": "ltr",
						"tl": "litro",
						"vi": "thư",
						"zh": "升"
					},
					"value": "ltr"
				},
				"label": {
					"translations": {
						"ar": "بولندي",
						"en": "Polish",
						"en-GB": "Polish",
						"en-US": "Polish",
						"es": "Polaco",
						"es-419": "Polaco",
						"es-ES": "Polaco",
						"he": "פּוֹלָנִית",
						"it": "Polacco",
						"pl": "Polski",
						"sw": "Kipolandi",
						"tl": "Polish",
						"vi": "Đánh bóng",
						"zh": "抛光"
					},
					"value": "Polish"
				},
				"labelFlag": {
					"translations": {
						"ar": "🇵🇱",
						"en": "🇵🇱",
						"en-GB": "🇵🇱",
						"en-US": "🇵🇱",
						"es": "🇵🇱",
						"es-419": "🇵🇱",
						"es-ES": "🇵🇱",
						"he": "🇵🇱",
						"it": "🇵🇱",
						"pl": "🇵🇱",
						"sw": "🇵🇱",
						"tl": "🇵🇱",
						"vi": "🇵🇱",
						"zh": "🇵🇱"
					},
					"value": "🇵🇱"
				}
			}
		},
		"index": 6
	}
}